// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2714%27 height=%2714%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%2352625a%27 stroke-width=%272%27%3E%3Cpath d=%27m6 9 6 6 6-6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%231B2420%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27m6 9 6 6 6-6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --bg:#EFF0EC;
  --surface:#F7F5F1;
  --white:#fff;
  --text:#13231D;
  --muted:#6C7771;
  --border:rgba(16,25,21,.10);
  --primary:#82B194;
  --primary-dark:#6F9A80;
  --soft:rgba(130,177,148,.13);
  --reserved:#5F8F70;
  --gold:#D6A640;
  --gold-soft:#F8F4E7;
  --shadow:0 12px 28px rgba(18,34,28,.06);
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  background: var(--bg);
  font-family: Sora, system-ui, sans-serif;
  color: var(--text);
}

button, input, select {
  font: inherit;
}

.shell {
  width: min(100vw - 28px, 1480px);
  margin: 8px auto;
  display: grid;
  grid-template-columns: 216px minmax(0, 1fr);
  gap: 22px;
}

.sidebar {
  background: var(--surface);
  border: 1px solid rgba(16, 25, 21, 0.05);
  border-radius: 26px;
  padding: 20px 14px;
  min-height: 820px;
}

.brand img {
  width: 126px;
  margin: 6px 6px 24px;
}

.side-title {
  font-size: 11px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #83908A;
  font-weight: 800;
  margin: 20px 10px 8px;
}

.nav {
  display: grid;
  gap: 7px;
}

.nav a {
  color: #5D6963;
  text-decoration: none;
  padding: 12px 14px;
  border-radius: 14px;
  font-size: 13px;
  font-weight: 600;
}

.nav a.active {
  background: var(--soft);
  border: 1px solid rgba(130, 177, 148, 0.34);
  color: var(--text);
  font-weight: 700;
}

.main {
  min-width: 0;
}

.topbar {
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 8px;
  margin-bottom: 6px;
  color: #5f6b65;
  font-size: 13px;
}

.workspace {
  background: var(--surface);
  border: 1px solid rgba(16, 25, 21, 0.05);
  border-radius: 28px;
  padding: 22px 24px 24px;
  box-shadow: var(--shadow);
}

.head {
  display: flex;
  justify-content: space-between;
  gap: 24px;
  align-items: flex-start;
  margin-bottom: 14px;
}

.head h1 {
  margin: 0;
  font-size: 28px;
  letter-spacing: -0.04em;
}

.head p {
  margin: 6px 0 0;
  color: var(--muted);
  font-size: 13px;
  line-height: 1.45;
  max-width: 760px;
}

.back {
  border: 1px solid var(--border);
  background: transparent;
  border-radius: 14px;
  padding: 10px 15px;
  font-weight: 700;
  color: var(--text);
  text-decoration: none;
  font-size: 13px;
}

.tabs {
  display: inline-flex;
  background: rgba(255, 255, 255, 0.58);
  border: 1px solid var(--border);
  padding: 4px;
  border-radius: 15px;
  margin-bottom: 18px;
}

.editor-tabs {
  display: flex;
  width: 100%;
  margin: 0 0 18px;
}

.editor-tabs .tab {
  flex: 1 1;
  padding: 9px 8px;
  font-size: 11px;
}

.editor-panel {
  display: none;
}

.editor-panel.active {
  display: block;
}

.tab {
  border: 0;
  background: transparent;
  border-radius: 11px;
  padding: 10px 15px;
  color: var(--muted);
  font-weight: 700;
  cursor: pointer;
}

.tab.active {
  background: var(--white);
  color: var(--text);
  box-shadow: 0 3px 10px rgba(18, 34, 28, 0.06);
}

.panel {
  display: none;
}

.panel.active {
  display: block;
}

.calendar-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 300px;
  gap: 14px;
  align-items: start;
}

.calendar-card, .editor-card {
  background: rgba(255, 255, 255, 0.58);
  border: 1px solid var(--border);
  border-radius: 20px;
}

.calendar-card {
  padding: 14px;
}

.calendar-toolbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.calendar-toolbar h2 {
  font-size: 15px;
  margin: 0;
}

.calendar-toolbar p {
  font-size: 11px;
  color: var(--muted);
  margin: 4px 0 0;
  line-height: 1.45;
}

.legend {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  font-size: 10px;
  color: var(--muted);
  font-weight: 600;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
}

.dot.available {
  background: var(--primary);
}

.dot.reserved {
  background: var(--reserved);
}

.week-grid {
  display: grid;
  touch-action: none;
  grid-template-columns: 56px repeat(7, minmax(82px, 1fr));
  position: relative;
  border: 1px solid var(--border);
  border-radius: 14px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.7);
  -webkit-user-select: none;
          user-select: none;
}

.corner {
  grid-column: 1;
  grid-row: 1;
  background: rgba(239, 240, 236, 0.55);
  border-right: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
}

.day-head {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 800;
  color: #617069;
  background: rgba(239, 240, 236, 0.55);
  border-right: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
  cursor: pointer;
}

.day-head:last-of-type {
  border-right: 0;
}

.day-head.active {
  background: var(--soft);
  color: #2F4A3F;
}

.time-label {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 2px;
  font-size: 9px;
  color: #89938E;
  border-right: 1px solid var(--border);
  border-bottom: 1px solid rgba(16, 25, 21, 0.045);
  z-index: 2;
}

.cell {
  border-right: 1px solid rgba(16, 25, 21, 0.055);
  border-bottom: 0;
  cursor: crosshair;
  position: relative;
}

.cell.half-hour {
  border-bottom: 1px solid rgba(16, 25, 21, 0.045);
}

.cell:hover {
  background: rgba(130, 177, 148, 0.07);
}

.cell.painting {
  background: rgba(130, 177, 148, 0.2);
}

.agenda-slot {
  position: relative;
  margin: 2px 3px;
  border-radius: 8px;
  background: rgba(130, 177, 148, 0.28);
  border: 1px solid rgba(111, 154, 128, 0.42);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 5px 4px;
  font-size: 9px;
  line-height: 1.3;
  font-weight: 800;
  color: #315044;
  z-index: 5;
  cursor: pointer;
  overflow: hidden;
}

.agenda-slot.selected {
  outline: 2px solid rgba(19, 35, 29, 0.34);
  outline-offset: -2px;
}

.agenda-slot.reserved {
  background: rgba(95, 143, 112, 0.26);
  border-color: rgba(95, 143, 112, 0.42);
  color: #2d4838;
  z-index: 8;
}

.agenda-slot .slot-label {
  pointer-events: none;
  padding-right: 14px;
}

.slot-menu-trigger {
  position: absolute;
  right: 2px;
  top: 2px;
  width: 18px;
  height: 18px;
  border: 0;
  border-radius: 7px;
  background: rgba(255, 255, 255, 0.86);
  color: #52625a;
  font-weight: 900;
  font-size: 14px;
  line-height: 16px;
  padding: 0;
  display: none;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 1px 4px rgba(18, 34, 28, 0.08);
}

.agenda-slot:hover .slot-menu-trigger, .agenda-slot.selected .slot-menu-trigger {
  display: flex;
}

.context-menu {
  position: fixed;
  z-index: 1000;
  display: none;
  min-width: 168px;
  padding: 6px;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 12px;
  box-shadow: 0 12px 30px rgba(18, 34, 28, 0.14);
}

.context-menu.open {
  display: block;
}

.selection-note strong {
  color: var(--text);
}

.editor-card {
  padding: 14px;
  position: sticky;
  top: 14px;
}

.editor-card h2 {
  font-size: 15px;
  margin: 0 0 5px;
}

.editor-card .lead {
  font-size: 11px;
  line-height: 1.45;
  color: var(--muted);
  margin: 0 0 12px;
}

.field {
  margin-bottom: 10px;
}

.field label {
  display: block;
  font-size: 10px;
  font-weight: 800;
  color: #6D7872;
  margin: 0 0 7px;
  letter-spacing: 0.02em;
}

.control {
  width: 100%;
  height: 42px;
  border: 1px solid var(--border);
  background: rgba(255, 255, 255, 0.82);
  border-radius: 12px;
  padding: 0 12px;
  color: var(--text);
  outline: none;
}

.time-picker {
  position: relative;
}

.time-picker-btn {
  width: 100%;
  height: 42px;
  border: 1px solid var(--border);
  background: rgba(255, 255, 255, 0.82);
  border-radius: 12px;
  padding: 0 12px;
  color: var(--text);
  font: inherit;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
}

.time-picker-btn:hover, .time-picker.open .time-picker-btn {
  border-color: rgba(130, 177, 148, 0.58);
  background: rgba(130, 177, 148, 0.07);
}

.time-picker-popover {
  display: none;
  position: absolute;
  z-index: 1200;
  top: 46px;
  left: 0;
  min-width: 164px;
  padding: 8px;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 12px;
  box-shadow: 0 12px 30px rgba(18, 34, 28, 0.14);
}

.time-picker.open .time-picker-popover {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
}

.time-list {
  max-height: 220px;
  overflow: auto;
  display: grid;
  gap: 3px;
}

.time-option {
  height: 30px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--text);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.time-option:hover {
  background: var(--soft);
}

.time-option.selected {
  background: var(--soft);
  color: #294439;
  box-shadow: inset 0 0 0 1px rgba(130, 177, 148, 0.32);
}

.time-picker-value {
  font-variant-numeric: tabular-nums;
}

.day-multi {
  position: relative;
}

.day-multi-btn {
  width: 100%;
  height: 42px;
  border: 1px solid var(--border);
  background: rgba(255, 255, 255, 0.82);
  border-radius: 12px;
  padding: 0 12px;
  color: var(--text);
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 500;
  cursor: pointer;
}

.day-multi.open .day-multi-btn {
  border-color: rgba(130, 177, 148, 0.58);
  background: rgba(130, 177, 148, 0.07);
}

.day-multi-popover {
  display: none;
  position: absolute;
  z-index: 1100;
  top: 46px;
  left: 0;
  right: 0;
  padding: 8px;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 12px;
  box-shadow: 0 12px 30px rgba(18, 34, 28, 0.14);
}

.day-multi.open .day-multi-popover {
  display: grid;
  gap: 3px;
}

.day-multi-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 8px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 600;
  color: #5f6b65;
  cursor: pointer;
}

.day-multi-option:hover {
  background: var(--soft);
}

.day-multi-option input {
  width: 15px;
  height: 15px;
  accent-color: var(--primary);
}

.pair {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.btn {
  height: 42px;
  border-radius: 12px;
  padding: 0 15px;
  border: 1px solid transparent;
  font-weight: 800;
  font-size: 12px;
  cursor: pointer;
}

.btn.primary {
  background: var(--primary);
  color: #fff;
}

.btn.primary:hover {
  background: var(--primary-dark);
}

.btn.secondary {
  background: transparent;
  border-color: rgba(19, 35, 29, 0.18);
  color: var(--text);
}

.btn.ghost {
  height: 36px;
  background: transparent;
  border-color: var(--border);
  color: #68746e;
}

.btn.danger {
  height: 36px;
  background: rgba(159, 169, 165, 0.08);
  border-color: rgba(159, 169, 165, 0.66);
  color: #56635D;
}

.btn-row {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.divider {
  height: 1px;
  background: var(--border);
  margin: 13px 0;
}

.selection-note {
  padding: 8px 10px;
  background: rgba(130, 177, 148, 0.08);
  border: 1px solid rgba(130, 177, 148, 0.2);
  border-radius: 12px;
  font-size: 10px;
  line-height: 1.5;
  color: #5d6d65;
  margin-bottom: 10px;
}

.small {
  font-size: 10px;
  color: var(--muted);
  line-height: 1.5;
}

.footer-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  border-top: 1px solid var(--border);
  padding-top: 18px;
  margin-top: 18px;
}

.toast {
  display: none;
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 11px;
  background: rgba(130, 177, 148, 0.12);
  color: #355044;
  font-size: 11px;
  font-weight: 700;
}

.toast.show {
  display: block;
}

.switchline {
  display: flex;
  align-items: center;
  gap: 9px;
  margin: 14px 0;
  font-size: 12px;
}

.checkbox {
  width: 18px;
  height: 18px;
  accent-color: var(--primary);
}

.calendar-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
  flex-wrap: wrap;
}

.period-nav, .view-switch {
  display: flex;
  align-items: center;
  gap: 6px;
}

.period-label {
  min-width: 172px;
  text-align: center;
  font-size: 12px;
  font-weight: 800;
  color: #44564e;
}

.nav-mini, .view-btn {
  height: 34px;
  border: 1px solid var(--border);
  background: rgba(255, 255, 255, 0.72);
  border-radius: 10px;
  padding: 0 10px;
  color: #52625a;
  font-size: 11px;
  font-weight: 800;
  cursor: pointer;
}

.nav-mini:hover, .view-btn:hover {
  background: var(--soft);
  border-color: rgba(130, 177, 148, 0.34);
}

.view-switch {
  padding: 3px;
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid var(--border);
  border-radius: 12px;
}

.view-btn {
  border: 0;
  background: transparent;
  height: 30px;
}

.view-btn.active {
  background: var(--soft);
  color: #294439;
  box-shadow: inset 0 0 0 1px rgba(130, 177, 148, 0.28);
}

.calendar-view {
  display: none;
}

.calendar-view.active {
  display: block;
}

.day-view {
  border: 1px solid var(--border);
  border-radius: 14px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.7);
  min-height: 520px;
}

.day-view-head {
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(239, 240, 236, 0.55);
  border-bottom: 1px solid var(--border);
  font-size: 11px;
  font-weight: 800;
}

.day-lane {
  position: relative;
  padding: 18px 22px 18px 74px;
  min-height: 475px;
  background: repeating-linear-gradient(to bottom, transparent 0, transparent 38px, rgba(16, 25, 21, 0.055) 39px);
}

.day-time {
  position: absolute;
  left: 18px;
  font-size: 9px;
  color: #89938E;
}

.day-slot {
  position: absolute;
  left: 76px;
  right: 24px;
  border-radius: 10px;
  padding: 8px 10px;
  font-size: 10px;
  font-weight: 800;
}

.day-slot.available {
  background: rgba(130, 177, 148, 0.2);
  border: 1px solid rgba(111, 154, 128, 0.36);
  color: #315044;
}

.month-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  border: 1px solid var(--border);
  border-radius: 14px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.7);
}

.month-head {
  padding: 10px 6px;
  text-align: center;
  background: rgba(239, 240, 236, 0.55);
  border-right: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
  font-size: 9px;
  font-weight: 800;
  color: #617069;
}

.month-day {
  min-height: 86px;
  padding: 8px;
  border-right: 1px solid rgba(16, 25, 21, 0.055);
  border-bottom: 1px solid rgba(16, 25, 21, 0.055);
  cursor: pointer;
}

.month-day:hover {
  background: rgba(130, 177, 148, 0.06);
}

.month-day.muted {
  opacity: 0.38;
}

.month-num {
  font-size: 10px;
  font-weight: 800;
}

.month-status {
  display: flex;
  gap: 4px;
  margin-top: 9px;
  flex-wrap: wrap;
}

.month-pill {
  height: 7px;
  border-radius: 99px;
  min-width: 28px;
  background: rgba(130, 177, 148, 0.35);
}

.month-pill.reserved {
  background: rgba(95, 143, 112, 0.52);
}

.replicate-btn {
  width: 100%;
  margin-top: 14px;
}

.replicate-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(19, 35, 29, 0.28);
  display: none;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 20px;
}

.replicate-backdrop.open {
  display: flex;
}

.modal-card {
  width: min(460px, 100%);
  background: #F7F5F1;
  border: 1px solid rgba(16, 25, 21, 0.1);
  border-radius: 20px;
  padding: 22px;
  box-shadow: 0 24px 60px rgba(18, 34, 28, 0.18);
}

.modal-card h3 {
  margin: 0 0 6px;
  font-size: 18px;
}

.modal-card p {
  margin: 0 0 18px;
  font-size: 11px;
  line-height: 1.55;
  color: var(--muted);
}

.replicate-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 18px;
}

.radio-stack {
  display: grid;
  gap: 8px;
  margin-top: 8px;
}

.radio-row {
  display: flex;
  gap: 9px;
  align-items: flex-start;
  padding: 9px 10px;
  border: 1px solid var(--border);
  border-radius: 11px;
  background: rgba(255, 255, 255, 0.6);
  font-size: 11px;
  color: #56645e;
}

.radio-row input {
  accent-color: var(--primary);
  margin-top: 2px;
}

.custom-range {
  display: none;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-top: 10px;
}

.custom-range.show {
  display: grid;
}

.system-select {
  appearance: none;
  background: rgba(255, 255, 255, 0.82) url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right 12px center;
  padding-right: 34px;
}

.replicate-note {
  padding: 10px 11px;
  background: rgba(130, 177, 148, 0.08);
  border: 1px solid rgba(130, 177, 148, 0.18);
  border-radius: 11px;
  font-size: 10px;
  line-height: 1.5;
  color: #5d6d65;
  margin-top: 12px;
}

.btn.primary {
  box-shadow: 0 5px 14px rgba(130, 177, 148, 0.18);
}

@media (max-width: 1180px) {
  .calendar-layout {
    grid-template-columns: 1fr;
  }
  .editor-card {
    position: static;
  }
  .week-grid {
    grid-template-columns: 48px repeat(7, minmax(68px, 1fr));
  }
}
@media (max-width: 850px) {
  .shell {
    grid-template-columns: 1fr;
  }
  .sidebar {
    display: none;
  }
  .workspace {
    padding: 20px;
  }
  .calendar-card {
    overflow: auto;
  }
  .week-grid {
    min-width: 780px;
  }
  .head {
    display: block;
  }
  .back {
    display: inline-block;
    margin-top: 12px;
  }
}
/* optimización de densidad y selección multidía */
.workspace {
  padding: 24px;
}

.head {
  margin-bottom: 16px;
}

.calendar-layout {
  grid-template-columns: minmax(0, 1fr) 292px;
  gap: 14px;
}

.calendar-card {
  padding: 14px;
}

.editor-card {
  padding: 14px;
  border-radius: 18px;
}

.calendar-card {
  border-radius: 18px;
}

.editor-tabs {
  margin-bottom: 14px;
}

.editor-tabs .tab {
  padding: 8px 6px;
}

.editor-card h2 {
  font-size: 14px;
}

.editor-card .lead {
  margin-bottom: 13px;
  line-height: 1.4;
}

.field {
  margin-bottom: 9px;
}

.field label {
  margin-bottom: 5px;
  font-size: 9px;
}

.control, .time-picker-btn, .day-multi-btn {
  height: 38px;
  border-radius: 11px;
}

.btn {
  height: 38px;
  border-radius: 11px;
}

.divider {
  margin: 13px 0;
}

.selection-note {
  padding: 9px 10px;
}

.footer-actions {
  margin-top: 14px;
}

.replicate-btn {
  margin-top: 10px;
}

.small {
  margin-top: 5px;
  line-height: 1.4;
}

.calendar-toolbar {
  margin-bottom: 10px;
}

.calendar-toolbar p {
  line-height: 1.35;
}

.day-multi-popover {
  padding: 8px;
  gap: 6px;
}

.day-multi.open .day-multi-popover {
  display: flex;
  flex-wrap: wrap;
}

.day-multi-option {
  position: relative;
  justify-content: center;
  padding: 7px 9px;
  min-width: 72px;
  border: 1px solid var(--border);
  background: rgba(255, 255, 255, 0.72);
  border-radius: 999px;
  color: #5f6b65;
}

.day-multi-option:hover {
  background: var(--soft);
  border-color: rgba(130, 177, 148, 0.32);
}

.day-multi-option input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.day-multi-option:has(input:checked) {
  background: var(--soft);
  border-color: rgba(130, 177, 148, 0.48);
  color: #294439;
}

.agenda-slot {
  border-radius: 7px;
}

.tab {
  font-size: 11px;
}

.nav a {
  padding: 11px 14px;
}

/* optimización visual y hoy */
.day-head {
  min-height: 42px;
  flex-direction: column;
  gap: 1px;
  line-height: 1.1;
}

.day-head .dow {
  font-size: 10px;
  font-weight: 800;
}

.day-head .date {
  font-size: 9px;
  font-weight: 600;
  color: #7b8781;
}

.day-head.today {
  background: var(--gold-soft);
  color: #7A5710;
  box-shadow: inset 0 -2px 0 rgba(214, 166, 64, 0.55);
}

.day-head.today .date {
  color: #8A6516;
  font-weight: 800;
}

.month-day.today {
  background: var(--gold-soft);
  box-shadow: inset 0 0 0 1px rgba(214, 166, 64, 0.38);
}

.month-day.today .month-num {
  display: inline-grid;
  place-items: center;
  min-width: 24px;
  height: 24px;
  border-radius: 999px;
  background: rgba(214, 166, 64, 0.2);
  color: #7A5710;
}

.day-view-head.today {
  background: var(--gold-soft);
  color: #7A5710;
}

.calendar-nav {
  margin-bottom: 10px;
}

.editor-tabs {
  margin-bottom: 12px;
}

.editor-tabs .tab {
  padding: 8px 7px;
}

.replicate-btn {
  margin-top: 10px;
}

.footer-actions {
  margin-top: 12px;
}

/* interacción y feedback final */
.selection-note {
  transition: background 0.16s ease, border-color 0.16s ease, color 0.16s ease;
}

.selection-note.state-available {
  background: rgba(130, 177, 148, 0.1);
  border-color: rgba(130, 177, 148, 0.28);
  color: #496158;
}

.selection-note.state-reserved {
  background: rgba(95, 143, 112, 0.12);
  border-color: rgba(95, 143, 112, 0.3);
  color: #3f5f4c;
}

.system-menu {
  position: relative;
}

.system-menu-btn {
  width: 100%;
  height: 38px;
  border: 1px solid var(--border);
  background: rgba(255, 255, 255, 0.82);
  border-radius: 11px;
  padding: 0 12px;
  color: var(--text);
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.08s ease, background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}

.system-menu-btn:hover, .system-menu.open .system-menu-btn {
  background: rgba(130, 177, 148, 0.07);
  border-color: rgba(130, 177, 148, 0.52);
  box-shadow: 0 0 0 3px rgba(130, 177, 148, 0.08);
}

.system-menu-btn:active {
  transform: translateY(1px);
}

.system-menu-popover {
  display: none;
  position: absolute;
  z-index: 1250;
  top: 42px;
  left: 0;
  right: 0;
  padding: 6px;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 11px;
  box-shadow: 0 12px 30px rgba(18, 34, 28, 0.14);
}

.system-menu.open .system-menu-popover {
  display: grid;
  gap: 2px;
}

.system-menu-option {
  height: 32px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #52625a;
  text-align: left;
  padding: 0 10px;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
}

.system-menu-option:hover {
  background: var(--soft);
}

.system-menu-option.selected {
  background: var(--soft);
  color: #294439;
  box-shadow: inset 0 0 0 1px rgba(130, 177, 148, 0.28);
}

.btn, .tab, .nav-mini, .view-btn, .day-multi-btn, .time-picker-btn {
  transition: transform 0.08s ease, background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
}

.btn:active, .tab:active, .nav-mini:active, .view-btn:active, .day-multi-btn:active, .time-picker-btn:active {
  transform: translateY(1px);
}

.btn.is-busy {
  pointer-events: none;
  opacity: 0.72;
}

.btn.is-success {
  background: rgba(130, 177, 148, 0.16) !important;
  border-color: rgba(130, 177, 148, 0.42) !important;
  color: #294439 !important;
}

.btn.primary.is-success {
  background: var(--primary) !important;
  color: #fff !important;
}

.day-multi-popover {
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 4px;
  padding: 7px;
}

.day-multi-option {
  position: relative;
  justify-content: center;
  align-items: center;
  padding: 0 3px;
  height: 32px;
  min-width: 0;
  border: 1px solid var(--border);
  background: rgba(255, 255, 255, 0.78);
  border-radius: 9px;
  font-size: 9.5px;
  line-height: 1;
  font-weight: 700;
  cursor: pointer;
  text-align: center;
  white-space: nowrap;
}

.day-multi-option input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.day-multi-option.checked {
  background: rgba(130, 177, 148, 0.16);
  border-color: rgba(130, 177, 148, 0.62);
  color: #294439;
  box-shadow: inset 0 0 0 1px rgba(130, 177, 148, 0.1);
}

.day-multi-option:hover {
  background: rgba(130, 177, 148, 0.09);
  border-color: rgba(130, 177, 148, 0.38);
}

/* consolidación visual: sin azul nativo, fechas y cápsulas del sistema */
.editor-tabs .tab.active {
  background: rgba(130, 177, 148, 0.11);
  color: #294439;
  box-shadow: inset 0 0 0 1px rgba(130, 177, 148, 0.24);
}

.date-picker {
  position: relative;
}

.date-picker-btn {
  width: 100%;
  height: 38px;
  border: 1px solid var(--border);
  background: rgba(255, 255, 255, 0.82);
  border-radius: 11px;
  padding: 0 12px;
  color: var(--text);
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease, transform 0.08s ease;
}

.date-picker-btn:hover, .date-picker.open .date-picker-btn {
  background: rgba(130, 177, 148, 0.07);
  border-color: rgba(130, 177, 148, 0.52);
  box-shadow: 0 0 0 3px rgba(130, 177, 148, 0.08);
}

.date-picker-btn:active {
  transform: translateY(1px);
}

.date-picker-popover {
  display: none;
  position: absolute;
  z-index: 1400;
  top: 42px;
  right: 0;
  width: 244px;
  padding: 9px;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 12px;
  box-shadow: 0 14px 34px rgba(18, 34, 28, 0.15);
}

.date-picker.open .date-picker-popover {
  display: block;
}

.date-picker-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  margin-bottom: 7px;
}

.date-picker-title {
  font-size: 10.5px;
  font-weight: 800;
  color: #344b41;
  text-transform: capitalize;
}

.date-picker-nav {
  display: flex;
  gap: 3px;
}

.date-picker-nav button, .date-picker-today {
  height: 28px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: #52625a;
  font-weight: 800;
  cursor: pointer;
}

.date-picker-nav button {
  width: 28px;
  font-size: 15px;
}

.date-picker-nav button:hover, .date-picker-today:hover {
  background: var(--soft);
  border-color: rgba(130, 177, 148, 0.26);
}

.date-week, .date-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
}

.date-week span {
  height: 24px;
  display: grid;
  place-items: center;
  font-size: 8.5px;
  font-weight: 800;
  color: #7a8780;
}

.date-day {
  height: 28px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: #3e4f47;
  font-size: 9.5px;
  font-weight: 700;
  cursor: pointer;
}

.date-day:hover {
  background: rgba(130, 177, 148, 0.08);
  border-color: rgba(130, 177, 148, 0.24);
}

.date-day.out {
  color: #a4ada8;
}

.date-day.selected {
  background: rgba(130, 177, 148, 0.18);
  border-color: rgba(130, 177, 148, 0.62);
  color: #294439;
  box-shadow: inset 0 0 0 1px rgba(130, 177, 148, 0.08);
}

.date-day.today {
  background: var(--gold-soft);
  border-color: rgba(214, 166, 64, 0.38);
  color: #7A5710;
}

.date-day.today.selected {
  box-shadow: inset 0 0 0 1px rgba(130, 177, 148, 0.55);
}

.date-picker-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 7px;
  padding-top: 7px;
  border-top: 1px solid var(--border);
}

.date-picker-today {
  padding: 0 9px;
  color: #557866;
  font-size: 9.5px;
}

input[type=checkbox], input[type=radio] {
  accent-color: var(--primary);
}

/* Cierre funcional 28/09 · interacción deliberada, jerarquía de estados y panel de excepciones */
.calendar-context-final {
  align-items: center;
}

.calendar-context-final p {
  max-width: 690px;
  font-size: 11.5px;
  line-height: 1.5;
  color: #65726c;
}

.calendar-context-final .legend {
  align-items: center;
  align-self: center;
}

.agenda-slot.reserved {
  z-index: 12 !important;
}

/* Alcance simplificado 29/09 */
.readonly-notice {
  display: none;
  padding: 14px;
  border: 1px solid rgba(130, 177, 148, 0.25);
  background: rgba(130, 177, 148, 0.07);
  border-radius: 14px;
}

.readonly-notice.show {
  display: block;
}

.readonly-notice strong {
  display: block;
  font-size: 13px;
  margin-bottom: 5px;
}

.readonly-notice p {
  margin: 0 0 10px;
  font-size: 11px;
  line-height: 1.45;
  color: var(--muted);
}

.month-day {
  cursor: pointer;
}

.day-view-readonly {
  display: flex;
  justify-content: flex-end;
  margin: 8px 0 0;
}

.view-btn[data-view=day]::after, .view-btn[data-view=month]::after {
  content: "";
}

.editor-card.readonly .editor-tabs, .editor-card.readonly .editor-panel {
  display: none !important;
}

[hidden] {
  display: none !important;
}

.time-picker-btn:disabled, .day-chip-inline:disabled {
  opacity: 0.55;
  cursor: default;
  background: rgba(239, 240, 236, 0.55) !important;
  border-color: var(--border) !important;
}

.day-chip-inline:disabled.checked {
  background: rgba(130, 177, 148, 0.17) !important;
  border-color: rgba(130, 177, 148, 0.58) !important;
  color: #315443 !important;
  opacity: 1;
}

/* pasada fina: Solicitud de horario como referencia visual */
:root {
  --reserved:#4F7F62;
  --reserved-strong:#426D53;
  --available-soft:rgba(130,177,148,.20);
  --reserved-soft:rgba(79,127,98,.38);
}

/* Tabs: mismo lenguaje de selección suave que Solicitud de horario */
.editor-tabs {
  display: grid !important;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  background: transparent !important;
  border: 0 !important;
  padding: 0 !important;
  border-radius: 0 !important;
}

.editor-tabs .tab {
  min-height: 38px;
  border: 1px solid rgba(130, 177, 148, 0.36) !important;
  border-radius: 14px !important;
  background: transparent !important;
  color: #5F6B65 !important;
  box-shadow: none !important;
}

.editor-tabs .tab:hover {
  background: rgba(130, 177, 148, 0.1) !important;
  border-color: rgba(130, 177, 148, 0.55) !important;
}

.editor-tabs .tab.active {
  background: rgba(130, 177, 148, 0.16) !important;
  border-color: var(--primary) !important;
  color: #32453B !important;
  box-shadow: none !important;
}

.editor-tabs .tab:active {
  transform: translateY(1px);
}

/* Disponibilidad vs reservado: verdes deliberadamente distintos */
.dot.available {
  background: #82B194 !important;
}

.dot.reserved {
  background: #4F7F62 !important;
}

.agenda-slot {
  background: var(--available-soft) !important;
  border-color: rgba(130, 177, 148, 0.48) !important;
  color: #315044 !important;
}

.agenda-slot.reserved {
  background: var(--reserved-soft) !important;
  border-color: rgba(79, 127, 98, 0.7) !important;
  color: #203D2E !important;
  box-shadow: inset 3px 0 0 rgba(66, 109, 83, 0.68);
}

.day-slot.available {
  background: rgba(130, 177, 148, 0.18) !important;
  border-color: rgba(130, 177, 148, 0.44) !important;
}

.month-pill {
  background: rgba(130, 177, 148, 0.34) !important;
}

.month-pill.reserved {
  background: rgba(79, 127, 98, 0.7) !important;
}

/* Aplicar a: mismas cápsulas que el selector por bloque de Solicitud */
.day-multi.open .day-multi-popover {
  display: grid !important;
  grid-template-columns: repeat(7, minmax(0, 1fr)) !important;
  gap: 6px !important;
  padding: 8px !important;
}

.day-multi-option {
  height: 34px !important;
  min-width: 0 !important;
  padding: 0 4px !important;
  border-radius: 10px !important;
  background: rgba(255, 255, 255, 0.72) !important;
  border: 1px solid rgba(19, 35, 29, 0.12) !important;
  color: var(--muted) !important;
  font-size: 10px !important;
  font-weight: 800 !important;
  display: grid !important;
  place-items: center !important;
}

.day-multi-option:hover {
  background: rgba(130, 177, 148, 0.1) !important;
  border-color: rgba(130, 177, 148, 0.34) !important;
}

.day-multi-option.checked {
  background: rgba(130, 177, 148, 0.16) !important;
  border-color: rgba(130, 177, 148, 0.48) !important;
  color: #426652 !important;
  box-shadow: none !important;
}

/* Campos: altura, radio y peso alineados al editor de Solicitud */
.time-picker-btn, .day-multi-btn, .system-menu-btn, .date-picker-btn {
  height: 38px !important;
  border-radius: 10px !important;
  font-size: 11.5px;
  font-weight: 700;
}

.time-option, .system-menu-option {
  font-size: 11px;
}

.time-option.selected, .system-menu-option.selected {
  background: rgba(130, 177, 148, 0.16) !important;
  color: #294439 !important;
  box-shadow: inset 0 0 0 1px rgba(130, 177, 148, 0.3) !important;
}

/* Estados interactivos visibles en todo el módulo derecho */
.back:hover, .btn.secondary:hover {
  background: rgba(130, 177, 148, 0.1) !important;
  border-color: rgba(130, 177, 148, 0.48) !important;
}

.btn.secondary:active, .back:active {
  background: rgba(130, 177, 148, 0.17) !important;
  border-color: var(--primary) !important;
}

.btn.primary:hover {
  background: var(--primary-dark) !important;
}

.btn.primary:active {
  background: #668E76 !important;
  box-shadow: 0 2px 7px rgba(102, 142, 118, 0.18) !important;
}

.btn:focus-visible, .back:focus-visible, .tab:focus-visible, .nav-mini:focus-visible, .view-btn:focus-visible, .day-multi-btn:focus-visible, .time-picker-btn:focus-visible, .system-menu-btn:focus-visible, .date-picker-btn:focus-visible {
  outline: 2px solid rgba(130, 177, 148, 0.38);
  outline-offset: 2px;
}

.nav-mini:hover, .view-btn:hover {
  background: rgba(130, 177, 148, 0.1) !important;
  border-color: rgba(130, 177, 148, 0.38) !important;
}

.view-btn.active {
  background: rgba(130, 177, 148, 0.16) !important;
  color: #294439 !important;
}

/* Leyenda con mejor lectura */
.legend {
  column-gap: 14px;
  row-gap: 6px;
}

.legend span {
  display: inline-flex;
  align-items: center;
}

.dot {
  width: 9px;
  height: 9px;
  margin-right: 6px;
}

/* Alcance simplificado 29/09 */
.readonly-notice {
  display: none;
  padding: 14px;
  border: 1px solid rgba(130, 177, 148, 0.25);
  background: rgba(130, 177, 148, 0.07);
  border-radius: 14px;
}

.readonly-notice.show {
  display: block;
}

.readonly-notice strong {
  display: block;
  font-size: 13px;
  margin-bottom: 5px;
}

.readonly-notice p {
  margin: 0 0 10px;
  font-size: 11px;
  line-height: 1.45;
  color: var(--muted);
}

.month-day {
  cursor: pointer;
}

.day-view-readonly {
  display: flex;
  justify-content: flex-end;
  margin: 8px 0 0;
}

.view-btn[data-view=day]::after, .view-btn[data-view=month]::after {
  content: "";
}

.editor-card.readonly .editor-tabs, .editor-card.readonly .editor-panel {
  display: none !important;
}

[hidden] {
  display: none !important;
}

.time-picker-btn:disabled, .day-chip-inline:disabled {
  opacity: 0.55;
  cursor: default;
  background: rgba(239, 240, 236, 0.55) !important;
  border-color: var(--border) !important;
}

.day-chip-inline:disabled.checked {
  background: rgba(130, 177, 148, 0.17) !important;
  border-color: rgba(130, 177, 148, 0.58) !important;
  color: #315443 !important;
  opacity: 1;
}

/* Cierre fino · encabezado, Aplicar a directo y excepciones funcionales */
.calendar-header-v2 {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 9px;
}

.calendar-heading-v2 {
  min-width: 0;
}

.calendar-title-line {
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
}

.calendar-title-line h2 {
  margin: 0;
  font-size: 15px;
  line-height: 1.2;
}

.calendar-title-line .period-label {
  font-size: 11px;
  font-weight: 700;
  color: #53645b;
}

.calendar-heading-v2 p {
  margin: 4px 0 0;
  max-width: 650px;
  font-size: 10.5px;
  line-height: 1.45;
  color: var(--muted);
}

.calendar-subbar-v2 {
  min-height: 34px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 9px;
  padding-top: 7px;
  border-top: 1px solid rgba(16, 25, 21, 0.07);
}

.calendar-subbar-v2 .period-nav {
  display: flex;
  align-items: center;
  gap: 6px;
}

.calendar-subbar-v2 .nav-mini {
  height: 30px;
  min-width: 30px;
}

.calendar-subbar-v2 .today-control {
  padding: 0 10px;
}

.view-switch {
  flex: 0 0 auto;
}

.legend {
  justify-content: flex-end;
}

.dot.available {
  background: #B8D7C3 !important;
  border: 1px solid #82B194;
}

.dot.reserved {
  background: #4F7F62 !important;
  border: 1px solid #426D53;
}

.agenda-slot {
  background: rgba(130, 177, 148, 0.18) !important;
  border-color: rgba(130, 177, 148, 0.46) !important;
}

.agenda-slot.reserved {
  background: rgba(79, 127, 98, 0.42) !important;
  border-color: rgba(66, 109, 83, 0.72) !important;
}

.apply-days-field {
  margin-bottom: 11px;
}

.day-chips-inline {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 5px;
}

.day-chip-inline {
  height: 32px;
  min-width: 0;
  padding: 0 2px;
  border: 1px solid rgba(19, 35, 29, 0.12);
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.78);
  color: #65726b;
  font-size: 9px;
  line-height: 1;
  font-weight: 800;
  display: grid;
  place-items: center;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, transform 0.08s ease;
}

.day-chip-inline:hover {
  background: rgba(130, 177, 148, 0.09);
  border-color: rgba(130, 177, 148, 0.38);
}

.day-chip-inline.checked {
  background: rgba(130, 177, 148, 0.17);
  border-color: rgba(130, 177, 148, 0.58);
  color: #315443;
}

.day-chip-inline.origin {
  box-shadow: inset 0 0 0 1px rgba(130, 177, 148, 0.18);
}

.day-chip-inline:active {
  transform: translateY(1px);
}

.day-chip-inline:focus-visible {
  outline: 2px solid rgba(130, 177, 148, 0.34);
  outline-offset: 2px;
}

@media (max-width: 980px) {
  .calendar-header-v2 {
    align-items: stretch;
  }
  .calendar-header-v2, .calendar-subbar-v2 {
    flex-wrap: wrap;
  }
  .legend {
    justify-content: flex-start;
  }
  .day-chips-inline {
    grid-template-columns: repeat(7, minmax(34px, 1fr));
  }
}
/* Alcance simplificado 29/09 */
.readonly-notice {
  display: none;
  padding: 14px;
  border: 1px solid rgba(130, 177, 148, 0.25);
  background: rgba(130, 177, 148, 0.07);
  border-radius: 14px;
}

.readonly-notice.show {
  display: block;
}

.readonly-notice strong {
  display: block;
  font-size: 13px;
  margin-bottom: 5px;
}

.readonly-notice p {
  margin: 0 0 10px;
  font-size: 11px;
  line-height: 1.45;
  color: var(--muted);
}

.month-day {
  cursor: pointer;
}

.day-view-readonly {
  display: flex;
  justify-content: flex-end;
  margin: 8px 0 0;
}

.view-btn[data-view=day]::after, .view-btn[data-view=month]::after {
  content: "";
}

.editor-card.readonly .editor-tabs, .editor-card.readonly .editor-panel {
  display: none !important;
}

[hidden] {
  display: none !important;
}

.time-picker-btn:disabled, .day-chip-inline:disabled {
  opacity: 0.55;
  cursor: default;
  background: rgba(239, 240, 236, 0.55) !important;
  border-color: var(--border) !important;
}

.day-chip-inline:disabled.checked {
  background: rgba(130, 177, 148, 0.17) !important;
  border-color: rgba(130, 177, 148, 0.58) !important;
  color: #315443 !important;
  opacity: 1;
}

/* cierre funcional para QA previo a desarrollo */
.calendar-header-final {
  display: grid;
  grid-template-columns: auto minmax(210px, 1fr) auto;
  align-items: center;
  gap: 14px;
  margin-bottom: 8px;
}

.calendar-header-final .period-nav {
  display: flex;
  gap: 6px;
  align-items: center;
}

.period-focus {
  text-align: center;
  display: grid;
  justify-items: center;
  gap: 2px;
  min-width: 0;
  padding: 7px 16px;
  border: 1px solid rgba(16, 25, 21, 0.08);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.62);
}

.period-mode {
  font-size: 9.5px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #738079;
}

.period-focus .period-label {
  min-width: 0;
  font-size: 17px;
  line-height: 1.15;
  font-weight: 800;
  color: #31463d;
  letter-spacing: -0.02em;
}

.calendar-context-final {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 10px;
  padding-top: 8px;
  border-top: 1px solid rgba(16, 25, 21, 0.07);
}

.calendar-context-final p {
  margin: 0;
  max-width: 660px;
  font-size: 10.5px;
  line-height: 1.45;
  color: var(--muted);
}

.calendar-context-final .legend {
  justify-content: flex-end;
}

.time-label-final {
  position: absolute;
  left: 0;
  bottom: 2px;
  width: 56px;
  transform: none;
  text-align: center;
  font-size: 9px;
  color: #89938E;
  z-index: 8;
  pointer-events: none;
  background: linear-gradient(to right, rgba(255, 255, 255, 0.92), rgba(255, 255, 255, 0.55));
  padding: 1px 0;
}

.day-lane {
  min-height: 594px !important;
  background: repeating-linear-gradient(to bottom, transparent 0, transparent 47px, rgba(16, 25, 21, 0.055) 48px) !important;
}

.period-nav .nav-mini:active, .view-btn:active, .btn:active, .tab:active, .day-chip-inline:active, .system-menu-btn:active, .time-picker-btn:active, .date-picker-btn:active {
  transform: translateY(1px);
}

.agenda-slot.reserved {
  z-index: 7;
}

.calendar-card {
  overflow: visible;
}

@media (max-width: 980px) {
  .calendar-header-final {
    grid-template-columns: 1fr auto;
  }
  .period-focus {
    grid-column: 1/-1;
    grid-row: 1;
  }
  .period-nav {
    grid-column: 1;
    grid-row: 2;
  }
  .calendar-header-final .view-switch {
    grid-column: 2;
    grid-row: 2;
  }
  .calendar-context-final {
    flex-wrap: wrap;
  }
  .calendar-context-final .legend {
    justify-content: flex-start;
  }
}
/* Alcance simplificado 29/09 */
.readonly-notice {
  display: none;
  padding: 14px;
  border: 1px solid rgba(130, 177, 148, 0.25);
  background: rgba(130, 177, 148, 0.07);
  border-radius: 14px;
}

.readonly-notice.show {
  display: block;
}

.readonly-notice strong {
  display: block;
  font-size: 13px;
  margin-bottom: 5px;
}

.readonly-notice p {
  margin: 0 0 10px;
  font-size: 11px;
  line-height: 1.45;
  color: var(--muted);
}

.month-day {
  cursor: pointer;
}

.day-view-readonly {
  display: flex;
  justify-content: flex-end;
  margin: 8px 0 0;
}

.view-btn[data-view=day]::after, .view-btn[data-view=month]::after {
  content: "";
}

.editor-card.readonly .editor-tabs, .editor-card.readonly .editor-panel {
  display: none !important;
}

[hidden] {
  display: none !important;
}

.time-picker-btn:disabled, .day-chip-inline:disabled {
  opacity: 0.55;
  cursor: default;
  background: rgba(239, 240, 236, 0.55) !important;
  border-color: var(--border) !important;
}

.day-chip-inline:disabled.checked {
  background: rgba(130, 177, 148, 0.17) !important;
  border-color: rgba(130, 177, 148, 0.58) !important;
  color: #315443 !important;
  opacity: 1;
}

/* =========================================================================
   Reserva directa · V28 Layout Oficial (editor-profesional-v28.css)
   ========================================================================= */
.workspace {
  display: grid !important;
  grid-template-columns: minmax(0, calc(66.666667% - 28px)) minmax(0, 1fr) !important;
  column-gap: 22px !important;
  grid-template-rows: auto auto !important;
  row-gap: 0 !important;
  align-items: start !important;
  padding: 0 !important;
  margin: 12px 0 0 !important;
  background: transparent !important;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  width: 100% !important;
}

.calendar-layout {
  display: contents !important;
}

.calendar-card {
  grid-column: 1 !important;
  grid-row: 1 !important;
  width: 100% !important;
  min-width: 0 !important;
  max-width: 100% !important;
  height: auto !important;
  min-height: 0 !important;
  max-height: none !important;
  padding: 24px !important;
  border: 1px solid rgba(16, 25, 21, 0.05) !important;
  border-radius: 24px !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03) !important;
  overflow: visible !important;
  background: #F7F5F1 !important;
}

.workspace > #editorActionZone {
  grid-column: 1 !important;
  grid-row: 2 !important;
  position: sticky !important;
  bottom: 20px !important;
  top: auto !important;
  z-index: 40 !important;
  box-sizing: border-box !important;
  width: 100% !important;
  max-width: none !important;
  margin: 0 !important;
  padding: 16px 0 0 !important;
}

#editorActionZone .save-pill {
  box-sizing: border-box !important;
  width: 100% !important;
  min-height: 74px !important;
  height: auto !important;
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 14px !important;
  padding: 12px 12px 12px 24px !important;
  border-radius: 28px !important;
  background: linear-gradient(90deg, #F8F0D4 0%, #FCF8EA 28%, #F7F5F1 52%, #F7F5F1 100%) !important;
  border: 1px solid rgba(16, 25, 21, 0.08) !important;
  box-shadow: 0 10px 18px rgba(18, 34, 28, 0.1) !important;
  animation: da-slideUp 0.4s ease-out forwards;
}

#editorActionZone .save-state {
  flex: 1 1 auto !important;
  min-width: 0 !important;
  display: flex !important;
  align-items: flex-start !important;
  gap: 10px !important;
}

#editorActionZone .save-dot {
  width: 10px !important;
  height: 10px !important;
  border-radius: 999px !important;
  background: #D6A640 !important;
  flex: 0 0 10px !important;
  margin-top: 5px !important;
  transition: background-color 0.3s ease, opacity 0.25s ease !important;
}
#editorActionZone .save-dot.save-dot--saved {
  background-color: rgba(19, 35, 29, 0.18) !important;
}

#editorActionZone .save-copy {
  font-size: 13px !important;
  font-weight: 800 !important;
  color: #13231D !important;
  line-height: 1.25 !important;
  margin-bottom: 2px !important;
}

#editorActionZone .save-sub {
  font-size: 12px !important;
  line-height: 1.35 !important;
  color: #6C7771 !important;
}

#editorActionZone .save-actions {
  flex: 0 0 auto !important;
  display: grid !important;
  grid-template-columns: 104px 148px !important;
  align-items: stretch !important;
  gap: 10px !important;
  flex-wrap: nowrap !important;
  width: auto !important;
}

#editorActionZone .save-actions > button {
  width: 100% !important;
  min-width: 0 !important;
  height: 42px !important;
  min-height: 42px !important;
  padding: 0 10px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 14px !important;
  white-space: nowrap !important;
  font-size: 13px !important;
  font-weight: 800 !important;
  cursor: pointer;
  transition: all 0.2s ease;
}

#editorActionZone .save-actions .btn-save-exit {
  background: transparent !important;
  border: 1px solid rgba(130, 177, 148, 0.4) !important;
  color: #13231D !important;
}
#editorActionZone .save-actions .btn-save-exit:hover {
  background: rgba(130, 177, 148, 0.05) !important;
}

#editorActionZone .save-actions .save-cta {
  background: #82B194 !important;
  border: none !important;
  color: #fff !important;
  box-shadow: none !important;
}
#editorActionZone .save-actions .save-cta:hover:not(:disabled) {
  background: #6F9A80 !important;
  transform: translateY(-1px);
}
#editorActionZone .save-actions .save-cta:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.calendar-card > .head {
  display: block !important;
  margin: 0 0 24px !important;
  padding: 0 !important;
}

.calendar-card > .head h1 {
  font-size: 20px !important;
  letter-spacing: -0.025em !important;
  line-height: 1.3 !important;
  font-weight: 800 !important;
  margin: 0 !important;
  color: var(--text, #13231D) !important;
}

.calendar-card > .head p {
  margin: 6px 0 0 !important;
  line-height: 1.55 !important;
  font-size: 13px !important;
  color: var(--muted, #6C7771) !important;
}

.calendar-card .calendar-header-final {
  display: grid !important;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr) !important;
  align-items: center !important;
  gap: 8px !important;
  margin-bottom: 12px !important;
}

.calendar-header-final .period-nav {
  justify-self: start !important;
  display: flex !important;
  align-items: center !important;
  gap: 6px !important;
}

.calendar-header-final .period-focus {
  justify-self: center !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: max-content !important;
  min-width: 154px !important;
  max-width: 100% !important;
  height: 34px !important;
  min-height: 34px !important;
  max-height: 34px !important;
  padding: 2px 14px !important;
  border: 1px solid rgba(16, 25, 21, 0.08) !important;
  border-radius: 12px !important;
  background: rgba(255, 255, 255, 0.62) !important;
}

.calendar-header-final .period-focus .period-label {
  font-size: 17px !important;
  line-height: 1.15 !important;
  font-weight: 800 !important;
  color: #31463d !important;
  letter-spacing: -0.02em !important;
}

.calendar-header-final .view-switch {
  justify-self: end !important;
  display: flex !important;
  align-items: center !important;
  width: max-content !important;
  height: 34px !important;
  min-height: 34px !important;
  max-height: 34px !important;
  padding: 2px !important;
  background: rgba(255, 255, 255, 0.5) !important;
  border: 1px solid var(--border) !important;
  border-radius: 12px !important;
}

.calendar-header-final .period-nav .nav-mini {
  height: 34px !important;
  min-height: 34px !important;
  border-radius: 10px !important;
}

.calendar-header-final .view-btn {
  height: 28px !important;
  min-height: 28px !important;
  border-radius: 9px !important;
  padding-inline: 10px !important;
}

.calendar-context-final {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 14px !important;
  margin-bottom: 12px !important;
  padding-top: 10px !important;
  border-top: 1px solid rgba(16, 25, 21, 0.07) !important;
}

#calendarHelp {
  max-width: none !important;
  min-width: 0 !important;
  flex: 1 1 auto !important;
  margin: 0 !important;
  padding: 10px 12px !important;
  border: 1px solid rgba(214, 166, 64, 0.35) !important;
  border-radius: 12px !important;
  background: #F8F4E7 !important;
  color: #13231D !important;
  font-weight: 600 !important;
  font-size: 11px !important;
  line-height: 1.55 !important;
}

.calendar-context-final .legend {
  flex: 0 0 auto !important;
  display: flex !important;
  align-items: center !important;
  gap: 14px !important;
  margin: 0 !important;
}

.week-grid {
  grid-template-columns: 56px repeat(7, minmax(0, 1fr)) !important;
  width: 100% !important;
  min-width: 0 !important;
  max-width: 100% !important;
}

.editor-column {
  position: sticky !important;
  top: 94px !important;
  display: flex !important;
  flex-direction: column !important;
  align-self: stretch !important;
  width: 100% !important;
  max-width: none !important;
  min-width: 0 !important;
  height: 100% !important;
  min-height: calc(100vh - 122px) !important;
  overflow: visible !important;
}

.editor-column .editor-card {
  position: static !important;
  width: 100% !important;
  flex: 1 1 auto !important;
  display: flex !important;
  flex-direction: column !important;
  min-height: 100% !important;
  padding: 24px !important;
  background: #F7F5F1 !important;
  border: 1px solid rgba(16, 25, 21, 0.05) !important;
  border-radius: 24px !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03) !important;
  overflow: visible !important;
}

.editor-card h2 {
  font-size: 16px !important;
  font-weight: 800 !important;
  margin: 0 0 5px !important;
}

.editor-card .lead {
  font-size: 12px !important;
  line-height: 1.45 !important;
  color: var(--muted, #6C7771) !important;
  margin: 0 0 14px !important;
}

.editor-tabs {
  display: grid !important;
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  gap: 8px !important;
  margin: 0 0 16px !important;
  padding: 0 !important;
  background: transparent !important;
  border: 0 !important;
}

.editor-tabs .tab {
  min-height: 38px !important;
  border: 1px solid rgba(130, 177, 148, 0.36) !important;
  border-radius: 12px !important;
  background: transparent !important;
  color: #5F6B65 !important;
  font-size: 12px !important;
  font-weight: 700 !important;
}

.editor-tabs .tab.active {
  background: rgba(130, 177, 148, 0.16) !important;
  border-color: var(--primary, #82B194) !important;
  color: #32453B !important;
  box-shadow: none !important;
}

.selection-note {
  padding: 10px 12px !important;
  background: rgba(130, 177, 148, 0.08) !important;
  border: 1px solid rgba(130, 177, 148, 0.2) !important;
  border-radius: 12px !important;
  font-size: 11px !important;
  line-height: 1.5 !important;
  color: #5d6d65 !important;
  margin-bottom: 12px !important;
}

.field label {
  display: block !important;
  font-size: 10px !important;
  font-weight: 800 !important;
  color: #6D7872 !important;
  margin: 0 0 6px !important;
  letter-spacing: 0.02em !important;
}

.time-picker-btn, .day-multi-btn, .system-menu-btn, .date-picker-btn {
  height: 38px !important;
  border-radius: 14px !important;
  font-size: 12px !important;
  font-weight: 700 !important;
}

.day-chips-inline {
  display: grid !important;
  grid-template-columns: repeat(7, minmax(0, 1fr)) !important;
  gap: 5px !important;
}

.day-chip-inline {
  height: 34px !important;
  border-radius: 10px !important;
  font-size: 9.5px !important;
  font-weight: 800 !important;
}

.availability-actions {
  display: grid !important;
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  gap: 8px !important;
  width: 100% !important;
  margin-top: 4px !important;
}

.availability-actions .btn {
  height: 40px !important;
  border-radius: 14px !important;
  font-weight: 800 !important;
  font-size: 12px !important;
}

.pause-inline-field {
  margin-top: 14px !important;
  margin-bottom: 12px !important;
}

.pause-inline-row {
  display: grid !important;
  grid-template-columns: 112px minmax(0, 1fr) !important;
  gap: 12px !important;
  align-items: center !important;
}

.replicate-btn {
  width: 100% !important;
  height: 40px !important;
  border-radius: 14px !important;
  margin-top: 14px !important;
  font-weight: 800 !important;
  font-size: 12px !important;
}

@media (max-width: 1380px) {
  .workspace {
    grid-template-columns: minmax(0, 1fr) !important;
    row-gap: 20px !important;
  }
  .calendar-layout {
    display: flex !important;
    flex-direction: column !important;
    gap: 20px !important;
  }
  .calendar-card {
    grid-column: auto !important;
    grid-row: auto !important;
    width: 100% !important;
  }
  .editor-column {
    grid-column: auto !important;
    grid-row: auto !important;
    position: static !important;
    max-height: none !important;
    width: 100% !important;
  }
  .workspace > #editorActionZone {
    grid-column: auto !important;
    grid-row: auto !important;
    width: 100% !important;
  }
}
/* Botón de eliminación en panel derecho y contenedor informativo */
.selected-range-info {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 12px !important;
  min-width: 0 !important;
}

.selected-range-copy {
  flex: 1 1 auto;
  min-width: 0;
  overflow-wrap: anywhere;
}

.delete-slot-icon {
  flex: 0 0 34px;
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  color: #D95C5C;
  border: 1px solid #D95C5C;
  border-radius: 12px !important;
  cursor: pointer;
  transition: all 0.15s ease;
  padding: 0;
  align-self: center;
}

.delete-slot-icon:hover, .delete-slot-icon:focus-visible {
  background: #D95C5C;
  color: #fff;
  outline-offset: 2px;
}

.delete-slot-icon[hidden] {
  display: none !important;
}

.day-slot.reserved {
  background: rgba(95, 143, 112, 0.26) !important;
  border: 1px solid rgba(66, 109, 83, 0.68) !important;
  color: #2d4838 !important;
  box-shadow: none !important;
}

.agenda-slot.reserved {
  border: 1px solid rgba(66, 109, 83, 0.68) !important;
  box-shadow: none !important;
  border-radius: 7px !important;
}

.pause-compact-menu {
  width: 112px;
  min-width: 112px;
}

.pause-compact-menu .system-menu-btn {
  width: 100%;
}

.pause-inline-help {
  margin: 0 !important;
  font-size: 10px !important;
  line-height: 1.45 !important;
  color: var(--muted);
  align-self: center;
}

@media (max-width: 520px) {
  .pause-inline-row {
    grid-template-columns: 1fr;
  }
  .pause-compact-menu {
    width: 100%;
    min-width: 0;
  }
  .pause-inline-help {
    margin-top: 2px !important;
  }
}
/* Reserva directa · acciones de edición de disponibilidad. */
.editor-tabs .tab[data-editor-tab=dateAdjustmentsEditor] {
  background: transparent !important;
  border-color: rgba(130, 177, 148, 0.3) !important;
  color: #43584e !important;
}

.editor-tabs .tab[data-editor-tab=dateAdjustmentsEditor]:hover {
  background: rgba(130, 177, 148, 0.1) !important;
  border-color: rgba(130, 177, 148, 0.42) !important;
  color: #32453B !important;
}

.editor-tabs .tab[data-editor-tab=dateAdjustmentsEditor].active {
  background: rgba(130, 177, 148, 0.16) !important;
  border-color: var(--primary) !important;
  color: #32453B !important;
  box-shadow: none !important;
}

.availability-edit-note {
  background: rgba(159, 169, 165, 0.12) !important;
  border-color: rgba(159, 169, 165, 0.48) !important;
  color: #56635D !important;
}

.date-adjust-status {
  margin-bottom: 14px !important;
}

.date-adjust-actions {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  margin-top: 4px;
}

.date-adjust-actions .btn {
  width: 100%;
}

#restoreHabitual {
  margin-top: 8px;
}

.btn.is-feedback {
  pointer-events: none;
}

.btn.is-invalid {
  background: rgba(159, 169, 165, 0.16) !important;
  border-color: rgba(159, 169, 165, 0.7) !important;
  color: #46524D !important;
}

.agenda-slot.adjusted {
  box-shadow: inset 0 0 0 1px rgba(130, 177, 148, 0.3);
}

.editor-action-zone .toast {
  display: none !important;
}

@media (min-width: 1321px) and (max-height: 900px) {
  .date-adjust-status {
    margin-bottom: 12px !important;
  }
}
/* Distribución aprobada de CTA: fila principal completa + tercer CTA full width. */
.availability-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  width: 100%;
}

.availability-actions .btn {
  width: 100%;
  min-width: 0;
}

/* Acceso directo contextual a Editar disponibilidad. */
.edit-availability-direct {
  display: block;
  width: 100%;
  margin-top: 8px;
  height: 35px;
  min-height: 35px !important;
  border: 1px solid rgba(130, 177, 148, 0.52) !important;
  border-radius: 10px;
  background: rgba(130, 177, 148, 0.055) !important;
  color: #375247 !important;
  font-size: 11px;
  font-weight: 800;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}

.edit-availability-direct:hover {
  background: rgba(130, 177, 148, 0.15) !important;
  border-color: #82B194 !important;
}

.edit-availability-direct[aria-pressed=true] {
  background: rgba(130, 177, 148, 0.19) !important;
  border-color: #82B194 !important;
}

.edit-availability-direct:focus-visible {
  outline: 2px solid rgba(130, 177, 148, 0.45);
  outline-offset: 2px;
}

.edit-availability-direct[hidden] {
  display: none !important;
}

.draft-selection {
  position: relative;
  margin: 2px 3px;
  border-radius: 8px;
  background: rgba(16, 25, 21, 0.05);
  border: 1px dashed rgba(16, 25, 21, 0.25);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 5px 4px;
  font-size: 9px;
  line-height: 1.3;
  font-weight: 800;
  color: #315044;
  z-index: 6;
  pointer-events: none;
  overflow: hidden;
}

/* Context menu: visible when .open, positioned fixed by React inline styles */
.context-menu {
  position: fixed !important;
  z-index: 2000 !important;
  display: none;
  width: 220px !important;
  min-width: 220px !important;
  max-width: calc(100vw - 16px) !important;
  padding: 6px !important;
  background: #fff !important;
  border: 1px solid rgba(16, 25, 21, 0.1) !important;
  border-radius: 12px !important;
  box-shadow: 0 12px 30px rgba(18, 34, 28, 0.14) !important;
}
.context-menu.open {
  display: flex !important;
  flex-direction: column !important;
  gap: 2px !important;
}
.context-menu button {
  width: 100% !important;
  display: flex !important;
  align-items: center !important;
  gap: 9px !important;
  text-align: left !important;
  padding: 11px 10px !important;
  border: 0 !important;
  border-radius: 9px !important;
  background: transparent !important;
  color: #13231D !important;
  font: 600 11px Sora, system-ui, sans-serif !important;
  cursor: pointer !important;
  transition: background 0.15s ease !important;
}
.context-menu button:hover {
  background: rgba(130, 177, 148, 0.12) !important;
}
.context-menu button.context-danger {
  color: #D95C5C !important;
  border-top: 1px solid rgba(16, 25, 21, 0.1) !important;
  border-radius: 0 0 9px 9px !important;
  margin-top: 3px !important;
  padding-top: 12px !important;
}
.context-menu button.context-danger:hover {
  background: rgba(217, 92, 92, 0.08) !important;
}

/* Replicate modal */
.replicate-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(19, 35, 29, 0.28);
  display: none;
  align-items: center;
  justify-content: center;
  z-index: 3000;
  padding: 20px;
  backdrop-filter: blur(2px);
}

.replicate-backdrop.open {
  display: flex;
}

.modal-card {
  width: min(460px, 100%);
  background: #F7F5F1;
  border: 1px solid rgba(16, 25, 21, 0.1);
  border-radius: 20px;
  padding: 22px;
  box-shadow: 0 24px 60px rgba(18, 34, 28, 0.18);
}

.modal-card h3 {
  margin: 0 0 6px;
  font-size: 18px;
}

.modal-card p {
  margin: 0 0 18px;
  font-size: 11px;
  line-height: 1.55;
  color: var(--muted);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 6px;
}

.modal-close {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--muted);
  font-size: 18px;
  line-height: 1;
  padding: 0;
}

.modal-close:hover {
  color: var(--text);
}

.replicate-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 18px;
}

.radio-stack {
  display: grid;
  gap: 8px;
  margin-top: 8px;
}

.radio-row {
  display: flex;
  gap: 9px;
  align-items: flex-start;
  padding: 9px 10px;
  border: 1px solid var(--border);
  border-radius: 11px;
  background: rgba(255, 255, 255, 0.6);
  font-size: 11px;
  color: #56645e;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
}

.radio-row:hover {
  background: var(--soft);
  border-color: rgba(130, 177, 148, 0.36);
}

.radio-row input {
  accent-color: var(--primary);
  margin-top: 2px;
}

.replicate-error {
  padding: 10px 11px;
  background: rgba(220, 53, 69, 0.08);
  border: 1px solid rgba(220, 53, 69, 0.18);
  border-radius: 11px;
  font-size: 10px;
  line-height: 1.5;
  color: #a51b29;
  margin-top: 12px;
}

.replicate-note {
  padding: 10px 11px;
  background: rgba(130, 177, 148, 0.08);
  border: 1px solid rgba(130, 177, 148, 0.18);
  border-radius: 11px;
  font-size: 10px;
  line-height: 1.5;
  color: #5d6d65;
  margin-top: 12px;
}

.replicate-backdrop.open {
  display: flex;
  align-items: center;
  justify-content: center;
}

.replicate-backdrop .modal-card {
  width: 100%;
  max-width: 420px;
  padding: 24px;
  border-radius: 16px;
  box-shadow: 0 16px 40px rgba(18, 34, 28, 0.15);
  background: #F7F5F1;
}

.replicate-backdrop .modal-header h3 {
  margin: 0 0 6px;
  font-size: 18px;
  font-weight: 800;
  color: #1B2420;
}

.replicate-backdrop .modal-header p {
  margin: 0 0 18px;
  font-size: 11px;
  line-height: 1.55;
  color: var(--muted);
}

.replicate-backdrop .field label {
  margin-bottom: 5px;
  font-size: 9px;
  font-weight: 800;
  color: #738079;
  letter-spacing: 0.04em;
  display: block;
}

.replicate-date-wrapper {
  --picker-h: 38px;
  --picker-bg: #FFFFFF;
}

.replicate-date-wrapper .date-picker-btn {
  height: 38px !important;
  border-radius: 10px !important;
  background: #FFFFFF !important;
  border: 1px solid #D1DBD5 !important;
  font-size: 13.5px !important;
  font-weight: 800 !important;
  color: #1B2420 !important;
  padding: 0 12px !important;
  position: relative;
}

.replicate-date-wrapper .date-picker-btn span:last-child {
  color: transparent !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: center;
  width: 20px;
  height: 20px;
  display: block;
}

.replicate-note {
  padding: 10px 11px;
  background: rgba(130, 177, 148, 0.08);
  border: 1px solid rgba(130, 177, 148, 0.18);
  border-radius: 11px;
  font-size: 10px;
  line-height: 1.5;
  color: #5d6d65;
  margin-top: 12px;
  font-weight: 500;
}

.replicate-actions {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.replicate-actions .btn {
  border-radius: 10px;
  height: 36px;
  padding: 0 16px;
  font-size: 12px;
  font-weight: 800;
}

.replicate-actions .btn.secondary {
  color: #1B2420;
  background: #FFFFFF;
  border: 1px solid #D1DBD5;
}

.replicate-actions .btn.primary {
  background: #84B396;
  color: #FFFFFF;
  border: none;
}

/* ── Floating Save Bar (Disponibilidad) ───────────────────── */
.da-save-bar {
  position: sticky;
  bottom: 20px;
  z-index: 1100;
  padding-top: 10px;
  margin-top: 2px;
  width: 100%;
  display: flex;
  justify-content: center;
  animation: da-slideUp 0.4s ease-out forwards;
}
.da-save-bar__pill {
  min-height: 74px;
  width: 100%;
  max-width: 1100px;
  border-radius: 28px;
  background: linear-gradient(90deg, #F8F0D4 0%, #FCF8EA 28%, #FAFBF9 52%, #FAFBF9 100%);
  border: 1px solid rgba(16, 25, 21, 0.08);
  box-shadow: 0 10px 18px rgba(18, 34, 28, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 12px 12px 12px 16px;
}
.da-save-bar__pill--dirty {
  background: linear-gradient(90deg, #DCEADF 0%, #EAF3ED 28%, #FAFBF9 52%, #FAFBF9 100%);
}
.da-save-bar__state {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
}
.da-save-bar__dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #D6A640;
  flex: 0 0 10px;
  margin-top: 6px;
  transition: background 0.25s ease;
}
.da-save-bar__dot--dirty {
  background: #82B194;
}
.da-save-bar__dot--saved {
  background: rgba(19, 35, 29, 0.18);
}
.da-save-bar__info {
  display: flex;
  flex-direction: column;
}
.da-save-bar__title {
  font-size: 13px;
  font-weight: 800;
  color: #101915;
  line-height: 1.25;
  margin-bottom: 2px;
}
.da-save-bar__subtitle {
  font-size: 12px;
  color: #6B7A71;
  line-height: 1.35;
}
.da-save-bar__actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}
.da-save-bar__btn-exit {
  min-width: 104px;
  min-height: 42px;
  border-radius: 14px;
  background: transparent;
  border: 1px solid rgba(130, 177, 148, 0.4);
  color: #101915;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
  transition: all 0.2s ease;
}
.da-save-bar__btn-exit:hover {
  background: rgba(130, 177, 148, 0.05);
}
.da-save-bar__btn-save {
  min-width: 160px;
  min-height: 42px;
  border-radius: 14px;
  background: #82B194;
  color: #ffffff;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 800;
  padding: 0 18px;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
}
.da-save-bar__btn-save:hover:not(:disabled) {
  background: #6A9A7C;
  transform: translateY(-1px);
}
.da-save-bar__btn-save:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.da-save-bar__spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: da-spin 0.7s linear infinite;
}

@keyframes da-slideUp {
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes da-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 700px) {
  .da-save-bar {
    bottom: 14px;
  }
  .da-save-bar__pill {
    border-radius: 24px;
    flex-direction: column;
    align-items: stretch;
    padding: 14px;
    height: auto;
  }
  .da-save-bar__btn-save, .da-save-bar__btn-exit {
    width: 100%;
    min-width: 0;
  }
}
.empty-week-banner {
  padding: 12px 16px;
  background-color: #FFF4E5;
  color: #663C00;
  border-radius: 4px;
  margin-bottom: 16px;
  font-size: 12px;
  border: 1px solid #FFD8A8;
}`, "",{"version":3,"sources":["webpack://./src/pages/DirectAvailabilityPage/direct-availability.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EAAM,YAAA;EAAa,iBAAA;EAAkB,YAAA;EAAa,cAAA;EAAe,eAAA;EAAgB,2BAAA;EAA4B,iBAAA;EAAkB,sBAAA;EAAuB,4BAAA;EAA6B,kBAAA;EAAmB,cAAA;EAAe,mBAAA;EAAoB,uCAAA;AAczO;;AAbA;EAAE,sBAAA;AAiBF;;AAjBwB;EAAK,SAAA;EAAS,qBAAA;EAAqB,wCAAA;EAAsC,kBAAA;AAwBjG;;AAxBmH;EAAoB,aAAA;AA4BvI;;AA5BoJ;EAAO,gCAAA;EAAqC,gBAAA;EAAgB,aAAA;EAAa,2CAAA;EAA0C,SAAA;AAoCvQ;;AApCgR;EAAS,0BAAA;EAA0B,wCAAA;EAAoC,mBAAA;EAAmB,kBAAA;EAAkB,iBAAA;AA4C5X;;AA5C6Y;EAAW,YAAA;EAAY,oBAAA;AAiDpa;;AAjDwb;EAAY,eAAA;EAAe,sBAAA;EAAqB,yBAAA;EAAyB,cAAA;EAAc,gBAAA;EAAgB,qBAAA;AA0D/hB;;AA1DojB;EAAK,aAAA;EAAa,QAAA;AA+DtkB;;AA/D8kB;EAAO,cAAA;EAAc,qBAAA;EAAqB,kBAAA;EAAkB,mBAAA;EAAmB,eAAA;EAAe,gBAAA;AAwE5qB;;AAxE4rB;EAAc,uBAAA;EAAuB,2CAAA;EAAuC,kBAAA;EAAkB,gBAAA;AA+E1xB;;AA/E0yB;EAAM,YAAA;AAmFhzB;;AAnF4zB;EAAQ,YAAA;EAAY,aAAA;EAAa,mBAAA;EAAmB,yBAAA;EAAyB,cAAA;EAAc,kBAAA;EAAkB,cAAA;EAAc,eAAA;AA8Fv7B;;AA9Fs8B;EAAW,0BAAA;EAA0B,wCAAA;EAAoC,mBAAA;EAAmB,uBAAA;EAAuB,yBAAA;AAsGzjC;;AAtGklC;EAAM,aAAA;EAAa,8BAAA;EAA8B,SAAA;EAAS,uBAAA;EAAuB,mBAAA;AA8GnqC;;AA9GsrC;EAAS,SAAA;EAAS,eAAA;EAAe,uBAAA;AAoHvtC;;AApH6uC;EAAQ,eAAA;EAAe,mBAAA;EAAmB,eAAA;EAAe,iBAAA;EAAiB,gBAAA;AA4HvzC;;AA5Hu0C;EAAM,+BAAA;EAA+B,uBAAA;EAAuB,mBAAA;EAAmB,kBAAA;EAAkB,gBAAA;EAAgB,kBAAA;EAAkB,qBAAA;EAAqB,eAAA;AAuI/9C;;AAvI8+C;EAAM,oBAAA;EAAoB,qCAAA;EAAiC,+BAAA;EAA+B,YAAA;EAAY,mBAAA;EAAmB,mBAAA;AAgJvmD;;AAhJ0nD;EAAa,aAAA;EAAa,WAAA;EAAW,gBAAA;AAsJ/pD;;AAtJ+qD;EAAkB,SAAA;EAAO,gBAAA;EAAgB,eAAA;AA4JxtD;;AA5JuuD;EAAc,aAAA;AAgKrvD;;AAhKkwD;EAAqB,cAAA;AAoKvxD;;AApKqyD;EAAK,SAAA;EAAS,uBAAA;EAAuB,mBAAA;EAAmB,kBAAA;EAAkB,mBAAA;EAAmB,gBAAA;EAAgB,eAAA;AA8Kl5D;;AA9Ki6D;EAAY,wBAAA;EAAwB,kBAAA;EAAkB,6CAAA;AAoLv9D;;AApLggE;EAAO,aAAA;AAwLvgE;;AAxLohE;EAAc,cAAA;AA4LliE;;AA5LgjE;EAAiB,aAAA;EAAa,2CAAA;EAA0C,SAAA;EAAS,kBAAA;AAmMjoE;;AAnMmpE;EAA4B,qCAAA;EAAiC,+BAAA;EAA+B,mBAAA;AAyM/uE;;AAzMkwE;EAAe,aAAA;AA6MjxE;;AA7M8xE;EAAkB,aAAA;EAAa,uBAAA;EAAuB,8BAAA;EAA8B,SAAA;EAAS,mBAAA;AAqN33E;;AArN84E;EAAqB,eAAA;EAAe,SAAA;AA0Nl7E;;AA1N27E;EAAoB,eAAA;EAAe,mBAAA;EAAmB,eAAA;EAAe,iBAAA;AAiOhgF;;AAjOihF;EAAQ,aAAA;EAAa,SAAA;EAAS,eAAA;EAAe,eAAA;EAAe,mBAAA;EAAmB,gBAAA;AA0OhmF;;AA1OgnF;EAAK,UAAA;EAAU,WAAA;EAAW,kBAAA;EAAkB,qBAAA;EAAqB,iBAAA;AAkPjrF;;AAlPksF;EAAe,0BAAA;AAsPjtF;;AAtP2uF;EAAc,2BAAA;AA0PzvF;;AA1PoxF;EAAW,aAAA;EAAa,kBAAA;EAAkB,wDAAA;EAAsD,kBAAA;EAAkB,+BAAA;EAA+B,mBAAA;EAAmB,gBAAA;EAAgB,oCAAA;EAAgC,yBAAA;UAAA,iBAAA;AAsQx+F;;AAtQy/F;EAAQ,cAAA;EAAc,WAAA;EAAW,qCAAA;EAAiC,qCAAA;EAAqC,sCAAA;AA8QhmG;;AA9QsoG;EAAU,aAAA;EAAa,mBAAA;EAAmB,uBAAA;EAAuB,eAAA;EAAe,gBAAA;EAAgB,cAAA;EAAc,qCAAA;EAAiC,qCAAA;EAAqC,sCAAA;EAAsC,eAAA;AA2Rh2G;;AA3R+2G;EAAuB,eAAA;AA+Rt4G;;AA/Rq5G;EAAiB,uBAAA;EAAuB,cAAA;AAoS77G;;AApS28G;EAAY,aAAA;EAAa,uBAAA;EAAuB,uBAAA;EAAuB,gBAAA;EAAgB,cAAA;EAAc,cAAA;EAAc,qCAAA;EAAqC,gDAAA;EAA4C,UAAA;AAgT/oH;;AAhTypH;EAAM,+CAAA;EAA2C,gBAAA;EAAgB,iBAAA;EAAiB,kBAAA;AAuT3uH;;AAvT6vH;EAAgB,gDAAA;AA2T7wH;;AA3TyzH;EAAY,qCAAA;AA+Tr0H;;AA/Ts2H;EAAe,oCAAA;AAmUr3H;;AAnUs5H;EAAa,kBAAA;EAAkB,eAAA;EAAe,kBAAA;EAAkB,qCAAA;EAAiC,2CAAA;EAAuC,aAAA;EAAa,uBAAA;EAAuB,uBAAA;EAAuB,gBAAA;EAAgB,cAAA;EAAc,gBAAA;EAAgB,gBAAA;EAAgB,cAAA;EAAc,UAAA;EAAU,eAAA;EAAe,gBAAA;AAsV9rI;;AAtV8sI;EAAsB,yCAAA;EAAqC,oBAAA;AA2VzwI;;AA3V6xI;EAAsB,oCAAA;EAAgC,sCAAA;EAAkC,cAAA;EAAc,UAAA;AAkWn4I;;AAlW64I;EAAyB,oBAAA;EAAoB,mBAAA;AAuW17I;;AAvW68I;EAAmB,kBAAA;EAAkB,UAAA;EAAU,QAAA;EAAQ,WAAA;EAAW,YAAA;EAAY,SAAA;EAAS,kBAAA;EAAkB,qCAAA;EAAiC,cAAA;EAAc,gBAAA;EAAgB,eAAA;EAAe,iBAAA;EAAiB,UAAA;EAAU,aAAA;EAAa,mBAAA;EAAmB,uBAAA;EAAuB,eAAA;EAAe,4CAAA;AA4XruJ;;AA5X6wJ;EAA+E,aAAA;AAgY51J;;AAhYy2J;EAAc,eAAA;EAAe,aAAA;EAAa,aAAA;EAAa,gBAAA;EAAgB,YAAA;EAAY,gBAAA;EAAgB,+BAAA;EAA+B,mBAAA;EAAmB,8CAAA;AA4Y9/J;;AA5YwiK;EAAmB,cAAA;AAgZ3jK;;AAhZykK;EAAuB,kBAAA;AAoZhmK;;AApZknK;EAAa,aAAA;EAAa,gBAAA;EAAgB,SAAA;AA0Z5pK;;AA1ZqqK;EAAgB,eAAA;EAAe,eAAA;AA+ZpsK;;AA/ZmtK;EAAmB,eAAA;EAAe,iBAAA;EAAiB,mBAAA;EAAmB,gBAAA;AAsazxK;;AAtayyK;EAAO,mBAAA;AA0ahzK;;AA1am0K;EAAa,cAAA;EAAc,eAAA;EAAe,gBAAA;EAAgB,cAAA;EAAc,eAAA;EAAe,sBAAA;AAmb15K;;AAnb+6K;EAAS,WAAA;EAAW,YAAA;EAAY,+BAAA;EAA+B,qCAAA;EAAiC,mBAAA;EAAmB,eAAA;EAAe,kBAAA;EAAkB,aAAA;AA8bnkL;;AA9bglL;EAAa,kBAAA;AAkc7lL;;AAlc+mL;EAAiB,WAAA;EAAW,YAAA;EAAY,+BAAA;EAA+B,qCAAA;EAAiC,mBAAA;EAAmB,eAAA;EAAe,kBAAA;EAAkB,aAAA;EAAa,gBAAA;EAAgB,aAAA;EAAa,mBAAA;EAAmB,uBAAA;EAAuB,QAAA;EAAQ,eAAA;AAmdv2L;;AAnds3L;EAA0D,uCAAA;EAAmC,qCAAA;AAwdn9L;;AAxdo/L;EAAqB,aAAA;EAAa,kBAAA;EAAkB,aAAA;EAAa,SAAA;EAAS,OAAA;EAAO,gBAAA;EAAgB,YAAA;EAAY,gBAAA;EAAgB,+BAAA;EAA+B,mBAAA;EAAmB,8CAAA;AAsenqM;;AAte6sM;EAAuC,aAAA;EAAa,8BAAA;EAA8B,QAAA;AA4e/xM;;AA5euyM;EAAW,iBAAA;EAAiB,cAAA;EAAc,aAAA;EAAa,QAAA;AAmf91M;;AAnfs2M;EAAa,YAAA;EAAY,SAAA;EAAS,kBAAA;EAAkB,uBAAA;EAAuB,kBAAA;EAAkB,eAAA;EAAe,gBAAA;EAAgB,eAAA;AA8fl+M;;AA9fi/M;EAAmB,uBAAA;AAkgBpgN;;AAlgB2hN;EAAsB,uBAAA;EAAuB,cAAA;EAAc,qDAAA;AAwgBtlN;;AAxgBuoN;EAAmB,kCAAA;AA4gB1pN;;AA5gB4rN;EAAW,kBAAA;AAghBvsN;;AAhhBytN;EAAe,WAAA;EAAW,YAAA;EAAY,+BAAA;EAA+B,qCAAA;EAAiC,mBAAA;EAAmB,eAAA;EAAe,kBAAA;EAAkB,aAAA;EAAa,mBAAA;EAAmB,8BAAA;EAA8B,gBAAA;EAAgB,eAAA;AA+hBj8N;;AA/hBg9N;EAA+B,uCAAA;EAAmC,qCAAA;AAoiBlhO;;AApiBmjO;EAAmB,aAAA;EAAa,kBAAA;EAAkB,aAAA;EAAa,SAAA;EAAS,OAAA;EAAO,QAAA;EAAQ,YAAA;EAAY,gBAAA;EAAgB,+BAAA;EAA+B,mBAAA;EAAmB,8CAAA;AAkjBxtO;;AAljBkwO;EAAmC,aAAA;EAAa,QAAA;AAujBlzO;;AAvjB0zO;EAAkB,aAAA;EAAa,mBAAA;EAAmB,QAAA;EAAQ,gBAAA;EAAgB,kBAAA;EAAkB,eAAA;EAAe,gBAAA;EAAgB,cAAA;EAAc,eAAA;AAmkBn8O;;AAnkBk9O;EAAwB,uBAAA;AAukB1+O;;AAvkBigP;EAAwB,WAAA;EAAW,YAAA;EAAY,4BAAA;AA6kBhjP;;AA7kB4kP;EAAM,aAAA;EAAa,8BAAA;EAA8B,QAAA;AAmlB7nP;;AAnlBqoP;EAAK,YAAA;EAAY,mBAAA;EAAmB,eAAA;EAAe,6BAAA;EAA6B,gBAAA;EAAgB,eAAA;EAAe,eAAA;AA6lBpvP;;AA7lBmwP;EAAa,0BAAA;EAA0B,WAAA;AAkmB1yP;;AAlmBqzP;EAAmB,+BAAA;AAsmBx0P;;AAtmBu2P;EAAe,uBAAA;EAAuB,oCAAA;EAAgC,kBAAA;AA4mB76P;;AA5mB+7P;EAAW,YAAA;EAAY,uBAAA;EAAuB,2BAAA;EAA2B,cAAA;AAmnBxgQ;;AAnnBshQ;EAAY,YAAA;EAAY,qCAAA;EAAiC,uCAAA;EAAmC,cAAA;AA0nBlnQ;;AA1nBgoQ;EAAS,aAAA;EAAa,QAAA;EAAQ,eAAA;AAgoB9pQ;;AAhoB6qQ;EAAS,WAAA;EAAW,yBAAA;EAAyB,cAAA;AAsoB1tQ;;AAtoBwuQ;EAAgB,iBAAA;EAAiB,qCAAA;EAAiC,0CAAA;EAAuC,mBAAA;EAAmB,eAAA;EAAe,gBAAA;EAAgB,cAAA;EAAc,mBAAA;AAipBj5Q;;AAjpBo6Q;EAAO,eAAA;EAAe,mBAAA;EAAmB,gBAAA;AAupB78Q;;AAvpB69Q;EAAgB,aAAA;EAAa,yBAAA;EAAyB,SAAA;EAAS,mCAAA;EAAmC,iBAAA;EAAiB,gBAAA;AAgqBhlR;;AAhqBgmR;EAAO,aAAA;EAAa,gBAAA;EAAgB,kBAAA;EAAkB,mBAAA;EAAmB,qCAAA;EAAiC,cAAA;EAAc,eAAA;EAAe,gBAAA;AA2qBvuR;;AA3qBuvR;EAAY,cAAA;AA+qBnwR;;AA/qBixR;EAAY,aAAA;EAAa,mBAAA;EAAmB,QAAA;EAAQ,cAAA;EAAc,eAAA;AAurBn1R;;AAvrBk2R;EAAU,WAAA;EAAW,YAAA;EAAY,4BAAA;AA6rBn4R;;AA5rBA;EAAc,aAAA;EAAa,mBAAA;EAAmB,8BAAA;EAA8B,SAAA;EAAS,mBAAA;EAAmB,eAAA;AAqsBxG;;AArsBuH;EAAyB,aAAA;EAAa,mBAAA;EAAmB,QAAA;AA2sBhL;;AA3sBwL;EAAc,gBAAA;EAAgB,kBAAA;EAAkB,eAAA;EAAe,gBAAA;EAAgB,cAAA;AAmtBvQ;;AAntBqR;EAAoB,YAAA;EAAY,+BAAA;EAA+B,qCAAA;EAAiC,mBAAA;EAAmB,eAAA;EAAe,cAAA;EAAc,eAAA;EAAe,gBAAA;EAAgB,eAAA;AA+tBpc;;AA/tBmd;EAAgC,uBAAA;EAAuB,uCAAA;AAouB1gB;;AApuB6iB;EAAa,YAAA;EAAY,oCAAA;EAAgC,+BAAA;EAA+B,mBAAA;AA2uBroB;;AA3uBwpB;EAAU,SAAA;EAAS,uBAAA;EAAuB,YAAA;AAivBlsB;;AAjvB8sB;EAAiB,uBAAA;EAAuB,cAAA;EAAc,qDAAA;AAuvBpwB;;AAvvBqzB;EAAe,aAAA;AA2vBp0B;;AA3vBi1B;EAAsB,cAAA;AA+vBv2B;;AA/vBq3B;EAAU,+BAAA;EAA+B,mBAAA;EAAmB,gBAAA;EAAgB,oCAAA;EAAgC,iBAAA;AAuwBj+B;;AAvwBk/B;EAAe,YAAA;EAAY,aAAA;EAAa,mBAAA;EAAmB,uBAAA;EAAuB,qCAAA;EAAiC,sCAAA;EAAsC,eAAA;EAAe,gBAAA;AAkxB1pC;;AAlxB0qC;EAAU,kBAAA;EAAkB,4BAAA;EAA4B,iBAAA;EAAiB,+GAAA;AAyxBnvC;;AAzxB21C;EAAU,kBAAA;EAAkB,UAAA;EAAU,cAAA;EAAc,cAAA;AAgyB/4C;;AAhyB65C;EAAU,kBAAA;EAAkB,UAAA;EAAU,WAAA;EAAW,mBAAA;EAAmB,iBAAA;EAAiB,eAAA;EAAe,gBAAA;AA0yBjgD;;AA1yBihD;EAAoB,oCAAA;EAAiC,2CAAA;EAAuC,cAAA;AAgzB7mD;;AAhzB2nD;EAAY,aAAA;EAAa,qCAAA;EAAoC,+BAAA;EAA+B,mBAAA;EAAmB,gBAAA;EAAgB,oCAAA;AAyzB1vD;;AAzzB0xD;EAAY,iBAAA;EAAiB,kBAAA;EAAkB,qCAAA;EAAiC,qCAAA;EAAqC,sCAAA;EAAsC,cAAA;EAAc,gBAAA;EAAgB,cAAA;AAo0Bn9D;;AAp0Bi+D;EAAW,gBAAA;EAAgB,YAAA;EAAY,+CAAA;EAA2C,gDAAA;EAA4C,eAAA;AA40B/lE;;AA50B8mE;EAAiB,qCAAA;AAg1B/nE;;AAh1BgqE;EAAiB,aAAA;AAo1BjrE;;AAp1B6rE;EAAW,eAAA;EAAe,gBAAA;AAy1BvtE;;AAz1BuuE;EAAc,aAAA;EAAa,QAAA;EAAQ,eAAA;EAAe,eAAA;AAg2BzxE;;AAh2BwyE;EAAY,WAAA;EAAW,mBAAA;EAAmB,eAAA;EAAe,qCAAA;AAu2Bj2E;;AAv2Bk4E;EAAqB,oCAAA;AA22Bv5E;;AA32Bu7E;EAAe,WAAA;EAAW,gBAAA;AAg3Bj9E;;AAh3Bi+E;EAAoB,eAAA;EAAe,QAAA;EAAQ,kCAAA;EAA8B,aAAA;EAAa,mBAAA;EAAmB,uBAAA;EAAuB,aAAA;EAAa,aAAA;AA23B9mF;;AA33B2nF;EAAyB,aAAA;AA+3BppF;;AA/3BiqF;EAAY,uBAAA;EAAsB,mBAAA;EAAmB,uCAAA;EAAoC,mBAAA;EAAmB,aAAA;EAAa,8CAAA;AAw4B1xF;;AAx4Bo0F;EAAe,eAAA;EAAe,eAAA;AA64Bl2F;;AA74Bi3F;EAAc,gBAAA;EAAgB,eAAA;EAAe,iBAAA;EAAiB,mBAAA;AAo5B/6F;;AAp5Bk8F;EAAmB,aAAA;EAAa,yBAAA;EAAyB,QAAA;EAAQ,gBAAA;AA25BngG;;AA35BmhG;EAAa,aAAA;EAAa,QAAA;EAAQ,eAAA;AAi6BrjG;;AAj6BokG;EAAW,aAAA;EAAa,QAAA;EAAQ,uBAAA;EAAuB,iBAAA;EAAiB,+BAAA;EAA+B,mBAAA;EAAmB,oCAAA;EAAgC,eAAA;EAAe,cAAA;AA66B7uG;;AA76B2vG;EAAiB,4BAAA;EAA4B,eAAA;AAk7BxyG;;AAl7BuzG;EAAc,aAAA;EAAa,8BAAA;EAA8B,QAAA;EAAQ,gBAAA;AAy7Bx3G;;AAz7Bw4G;EAAmB,aAAA;AA67B35G;;AA77Bw6G;EAAe,gBAAA;EAAgB,yGAAA;EAAqQ,mBAAA;AAm8B5sH;;AAn8B+tH;EAAgB,kBAAA;EAAkB,qCAAA;EAAiC,2CAAA;EAAuC,mBAAA;EAAmB,eAAA;EAAe,gBAAA;EAAgB,cAAA;EAAc,gBAAA;AA88Bz4H;;AA98By5H;EAAa,gDAAA;AAk9Bt6H;;AAj9BA;EAA0B;IAAiB,0BAAA;EAs9BzC;EAt9BmE;IAAa,gBAAA;EAy9BhF;EAz9BgG;IAAW,wDAAA;EA49B3G;AACF;AA79BoK;EAAyB;IAAO,0BAAA;EAi+BlM;EAj+B4N;IAAS,aAAA;EAo+BrO;EAp+BkP;IAAW,aAAA;EAu+B7P;EAv+B0Q;IAAe,cAAA;EA0+BzR;EA1+BuS;IAAW,gBAAA;EA6+BlT;EA7+BkU;IAAM,cAAA;EAg/BxU;EAh/BsV;IAAM,qBAAA;IAAqB,gBAAA;EAo/BjX;AACF;AAn/BA,kDAAA;AACA;EAAW,aAAA;AAs/BX;;AAt/BwB;EAAM,mBAAA;AA0/B9B;;AA1/BiD;EAAiB,2CAAA;EAA0C,SAAA;AA+/B5G;;AA//BqH;EAAe,aAAA;AAmgCpI;;AAngCiJ;EAAa,aAAA;EAAa,mBAAA;AAwgC3K;;AAxgC8L;EAAe,mBAAA;AA4gC7M;;AA5gCgO;EAAa,mBAAA;AAghC7O;;AAhhCgQ;EAAkB,gBAAA;AAohClR;;AAphCkS;EAAgB,eAAA;AAwhClT;;AAxhCiU;EAAmB,mBAAA;EAAmB,gBAAA;AA6hCvW;;AA7hCuX;EAAO,kBAAA;AAiiC9X;;AAjiCgZ;EAAa,kBAAA;EAAkB,cAAA;AAsiC/a;;AAtiC6b;EAAyC,YAAA;EAAY,mBAAA;AA2iClf;;AA3iCqgB;EAAK,YAAA;EAAY,mBAAA;AAgjCthB;;AAhjCyiB;EAAS,cAAA;AAojCljB;;AApjCgkB;EAAgB,iBAAA;AAwjChlB;;AAxjCimB;EAAgB,gBAAA;AA4jCjnB;;AA5jCioB;EAAe,gBAAA;AAgkChpB;;AAhkCgqB;EAAO,eAAA;EAAe,gBAAA;AAqkCtrB;;AArkCssB;EAAkB,mBAAA;AAykCxtB;;AAzkC2uB;EAAoB,iBAAA;AA6kC/vB;;AA7kCgxB;EAAmB,YAAA;EAAY,QAAA;AAklC/yB;;AAllCuzB;EAAmC,aAAA;EAAa,eAAA;AAulCv2B;;AAvlCs3B;EAAkB,kBAAA;EAAkB,uBAAA;EAAuB,gBAAA;EAAgB,eAAA;EAAe,+BAAA;EAA+B,qCAAA;EAAiC,oBAAA;EAAoB,cAAA;AAkmCpiC;;AAlmCkjC;EAAwB,uBAAA;EAAuB,uCAAA;AAumCjmC;;AAvmCooC;EAAwB,kBAAA;EAAkB,UAAA;EAAU,oBAAA;AA6mCxrC;;AA7mC4sC;EAAqC,uBAAA;EAAuB,uCAAA;EAAmC,cAAA;AAmnC3yC;;AAnnCyzC;EAAa,kBAAA;AAunCt0C;;AAvnCw1C;EAAK,eAAA;AA2nC71C;;AA3nC42C;EAAO,kBAAA;AA+nCn3C;;AA7nCA,8BAAA;AACA;EAAU,gBAAA;EAAgB,sBAAA;EAAsB,QAAA;EAAQ,gBAAA;AAooCxD;;AAnoCA;EAAe,eAAA;EAAe,gBAAA;AAwoC9B;;AAvoCA;EAAgB,cAAA;EAAc,gBAAA;EAAgB,cAAA;AA6oC9C;;AA5oCA;EAAgB,4BAAA;EAA4B,cAAA;EAAc,mDAAA;AAkpC1D;;AAjpCA;EAAsB,cAAA;EAAc,gBAAA;AAspCpC;;AArpCA;EAAiB,4BAAA;EAA4B,oDAAA;AA0pC7C;;AAzpCA;EAA4B,oBAAA;EAAoB,mBAAA;EAAmB,eAAA;EAAe,YAAA;EAAY,oBAAA;EAAoB,mCAAA;EAAgC,cAAA;AAmqClJ;;AAlqCA;EAAqB,4BAAA;EAA4B,cAAA;AAuqCjD;;AAtqCA;EAAc,mBAAA;AA0qCd;;AAzqCA;EAAa,mBAAA;AA6qCb;;AA5qCA;EAAkB,gBAAA;AAgrClB;;AA/qCA;EAAe,gBAAA;AAmrCf;;AAlrCA;EAAgB,gBAAA;AAsrChB;;AAprCA,iCAAA;AACA;EAAgB,4EAAA;AAwrChB;;AAvrCA;EAAgC,oCAAA;EAAiC,uCAAA;EAAmC,cAAA;AA6rCpG;;AA5rCA;EAA+B,oCAAA;EAAgC,qCAAA;EAAkC,cAAA;AAksCjG;;AAhsCA;EAAa,kBAAA;AAosCb;;AApsC+B;EAAiB,WAAA;EAAW,YAAA;EAAY,+BAAA;EAA+B,qCAAA;EAAiC,mBAAA;EAAmB,eAAA;EAAe,kBAAA;EAAkB,aAAA;EAAa,mBAAA;EAAmB,8BAAA;EAA8B,gBAAA;EAAgB,eAAA;EAAe,uGAAA;AAotCxR;;AAptCwX;EAA0D,qCAAA;EAAiC,uCAAA;EAAmC,+CAAA;AA0tCtf;;AA1tCiiB;EAAwB,0BAAA;AA8tCzjB;;AA9tCmlB;EAAqB,aAAA;EAAa,kBAAA;EAAkB,aAAA;EAAa,SAAA;EAAS,OAAA;EAAO,QAAA;EAAQ,YAAA;EAAY,gBAAA;EAAgB,+BAAA;EAA+B,mBAAA;EAAmB,8CAAA;AA4uC1vB;;AA5uCoyB;EAAuC,aAAA;EAAa,QAAA;AAivCx1B;;AAjvCg2B;EAAoB,YAAA;EAAY,SAAA;EAAS,kBAAA;EAAkB,uBAAA;EAAuB,cAAA;EAAc,gBAAA;EAAgB,eAAA;EAAe,eAAA;EAAe,gBAAA;EAAgB,eAAA;AA8vC9/B;;AA9vC6gC;EAA0B,uBAAA;AAkwCviC;;AAlwC8jC;EAA6B,uBAAA;EAAuB,cAAA;EAAc,qDAAA;AAwwChoC;;AAvwCA;EAA8D,2HAAA;AA2wC9D;;AA3wCgL;EAAwG,0BAAA;AA+wCxR;;AA/wCkT;EAAa,oBAAA;EAAoB,aAAA;AAoxCnV;;AApxC+V;EAAgB,gDAAA;EAA2C,kDAAA;EAA6C,yBAAA;AA0xCvc;;AA1xC+d;EAAwB,qCAAA;EAAoC,sBAAA;AA+xC3hB;;AA9xCA;EAAmB,gDAAA;EAA8C,QAAA;EAAQ,YAAA;AAoyCzE;;AApyCqF;EAAkB,kBAAA;EAAkB,uBAAA;EAAuB,mBAAA;EAAmB,cAAA;EAAc,YAAA;EAAY,YAAA;EAAY,+BAAA;EAA+B,qCAAA;EAAiC,kBAAA;EAAkB,gBAAA;EAAgB,cAAA;EAAc,gBAAA;EAAgB,eAAA;EAAe,kBAAA;EAAkB,mBAAA;AAszC1W;;AAtzC6X;EAAwB,kBAAA;EAAkB,UAAA;EAAU,oBAAA;AA4zCjb;;AA5zCqc;EAA0B,qCAAA;EAAiC,uCAAA;EAAmC,cAAA;EAAc,oDAAA;AAm0CjjB;;AAn0CkmB;EAAwB,qCAAA;EAAiC,uCAAA;AAw0C3pB;;AAr0CA,yEAAA;AACA;EAAyB,qCAAA;EAAiC,cAAA;EAAc,qDAAA;AA20CxE;;AA10CA;EAAa,kBAAA;AA80Cb;;AA90C+B;EAAiB,WAAA;EAAW,YAAA;EAAY,+BAAA;EAA+B,qCAAA;EAAiC,mBAAA;EAAmB,eAAA;EAAe,kBAAA;EAAkB,aAAA;EAAa,mBAAA;EAAmB,8BAAA;EAA8B,gBAAA;EAAgB,eAAA;EAAe,uGAAA;AA81CxR;;AA91CwX;EAA0D,qCAAA;EAAiC,uCAAA;EAAmC,+CAAA;AAo2Ctf;;AAp2CiiB;EAAwB,0BAAA;AAw2CzjB;;AAx2CmlB;EAAqB,aAAA;EAAa,kBAAA;EAAkB,aAAA;EAAa,SAAA;EAAS,QAAA;EAAQ,YAAA;EAAY,YAAA;EAAY,gBAAA;EAAgB,+BAAA;EAA+B,mBAAA;EAAmB,8CAAA;AAs3C/vB;;AAt3CyyB;EAAuC,cAAA;AA03Ch1B;;AA13C81B;EAAkB,aAAA;EAAa,mBAAA;EAAmB,8BAAA;EAA8B,QAAA;EAAQ,kBAAA;AAk4Ct7B;;AAl4Cw8B;EAAmB,iBAAA;EAAiB,gBAAA;EAAgB,cAAA;EAAc,0BAAA;AAy4C1gC;;AAz4CoiC;EAAiB,aAAA;EAAa,QAAA;AA84ClkC;;AA94C0kC;EAA2C,YAAA;EAAY,6BAAA;EAA6B,kBAAA;EAAkB,uBAAA;EAAuB,cAAA;EAAc,gBAAA;EAAgB,eAAA;AAw5CruC;;AAx5CovC;EAAwB,WAAA;EAAW,eAAA;AA65CvxC;;AA75CsyC;EAAuD,uBAAA;EAAuB,uCAAA;AAk6Cp3C;;AAl6Cu5C;EAAsB,aAAA;EAAa,qCAAA;EAAoC,QAAA;AAw6C99C;;AAx6Cs+C;EAAgB,YAAA;EAAY,aAAA;EAAa,mBAAA;EAAmB,gBAAA;EAAgB,gBAAA;EAAgB,cAAA;AAi7ClkD;;AAj7CglD;EAAU,YAAA;EAAY,6BAAA;EAA6B,kBAAA;EAAkB,uBAAA;EAAuB,cAAA;EAAc,gBAAA;EAAgB,gBAAA;EAAgB,eAAA;AA47C1tD;;AA57CyuD;EAAgB,qCAAA;EAAiC,uCAAA;AAi8C1xD;;AAj8C6zD;EAAc,cAAA;AAq8C30D;;AAr8Cy1D;EAAmB,qCAAA;EAAiC,uCAAA;EAAmC,cAAA;EAAc,qDAAA;AA48C97D;;AA58C++D;EAAgB,4BAAA;EAA4B,sCAAA;EAAkC,cAAA;AAk9C7jE;;AAl9C2kE;EAAyB,qDAAA;AAs9CpmE;;AAt9CqpE;EAAoB,aAAA;EAAa,yBAAA;EAAyB,eAAA;EAAe,gBAAA;EAAgB,mCAAA;AA89C9uE;;AA99CixE;EAAmB,cAAA;EAAc,cAAA;EAAc,gBAAA;AAo+Ch0E;;AAn+CA;EAA2C,4BAAA;AAu+C3C;;AAr+CA,iGAAA;AACA;EAAwB,mBAAA;AAy+CxB;;AAx+CA;EAA0B,gBAAA;EAAgB,iBAAA;EAAiB,gBAAA;EAAgB,cAAA;AA++C3E;;AA9+CA;EAAgC,mBAAA;EAAmB,kBAAA;AAm/CnD;;AAl/CA;EAAsB,sBAAA;AAs/CtB;;AAx+CA,+BAAA;AACA;EAAiB,aAAA;EAAa,aAAA;EAAa,2CAAA;EAAuC,qCAAA;EAAiC,mBAAA;AAg/CnH;;AAh/CsI;EAAsB,cAAA;AAo/C5J;;AAp/C0K;EAAwB,cAAA;EAAc,eAAA;EAAe,kBAAA;AA0/C/N;;AA1/CiP;EAAmB,gBAAA;EAAgB,eAAA;EAAe,iBAAA;EAAiB,mBAAA;AAigDpT;;AAjgDuU;EAAW,eAAA;AAqgDlV;;AArgDiW;EAAmB,aAAA;EAAa,yBAAA;EAAyB,eAAA;AA2gD1Z;;AA3gDya;EAAsE,WAAA;AA+gD/e;;AA/gD0f;EAAuE,wBAAA;AAmhDjkB;;AAnhDwlB;EAAS,wBAAA;AAuhDjmB;;AAvhDwnB;EAAoD,aAAA;EAAY,eAAA;EAAe,gDAAA;EAA2C,sCAAA;AA8hDlvB;;AA7hDA;EAAkC,gDAAA;EAA2C,kDAAA;EAA6C,yBAAA;EAAwB,UAAA;AAoiDlJ;;AAjiDA,6DAAA;AACA;EAAM,kBAAA;EAAmB,yBAAA;EAA0B,sCAAA;EAAuC,mCAAA;AAwiD1F;;AAviDA,qEAAA;AACA;EAAa,wBAAA;EAAuB,gDAAA;EAA8C,SAAA;EAAS,kCAAA;EAAiC,oBAAA;EAAmB,qBAAA;EAAoB,2BAAA;AAijDnK;;AAhjDA;EAAkB,gBAAA;EAAgB,sDAAA;EAAiD,8BAAA;EAA6B,kCAAA;EAAiC,yBAAA;EAAwB,2BAAA;AAyjDzK;;AAxjDA;EAAwB,+CAAA;EAA2C,kDAAA;AA6jDnE;;AA5jDA;EAAyB,gDAAA;EAA2C,uCAAA;EAAsC,yBAAA;EAAwB,2BAAA;AAmkDlI;;AAlkDA;EAAyB,0BAAA;AAskDzB;;AArkDA,kEAAA;AACA;EAAe,8BAAA;AAykDf;;AAzkD4C;EAAc,8BAAA;AA6kD1D;;AA5kDA;EAAa,4CAAA;EAA2C,kDAAA;EAA6C,yBAAA;AAklDrG;;AAjlDA;EAAsB,2CAAA;EAA0C,+CAAA;EAA2C,yBAAA;EAAwB,iDAAA;AAwlDnI;;AAtlDA;EAAoB,gDAAA;EAA2C,kDAAA;AA2lD/D;;AA3lD4G;EAAY,gDAAA;AA+lDxH;;AA/lDmK;EAAqB,6CAAA;AAmmDxL;;AAlmDA,uEAAA;AACA;EAAmC,wBAAA;EAAuB,2DAAA;EAAwD,mBAAA;EAAkB,uBAAA;AAymDpI;;AAxmDA;EAAkB,uBAAA;EAAsB,uBAAA;EAAsB,yBAAA;EAAwB,8BAAA;EAA6B,gDAAA;EAA2C,mDAAA;EAA8C,8BAAA;EAA6B,0BAAA;EAAyB,2BAAA;EAA0B,wBAAA;EAAuB,8BAAA;AAsnDnT;;AArnDA;EAAwB,+CAAA;EAA2C,kDAAA;AA0nDnE;;AAznDA;EAA0B,gDAAA;EAA2C,kDAAA;EAA6C,yBAAA;EAAwB,2BAAA;AAgoD1I;;AA/nDA,kEAAA;AACA;EAAkE,uBAAA;EAAsB,8BAAA;EAA6B,iBAAA;EAAiB,gBAAA;AAsoDtI;;AAroDA;EAAiC,eAAA;AAyoDjC;;AAzoDgD;EAAmD,gDAAA;EAA2C,yBAAA;EAAwB,+DAAA;AA+oDtK;;AA9oDA,4DAAA;AAEA;EAAiC,+CAAA;EAA2C,kDAAA;AAkpD5E;;AAhpDA;EAAmC,gDAAA;EAA2C,uCAAA;AAqpD9E;;AAppDA;EAAmB,0CAAA;AAwpDnB;;AAxpD4D;EAAoB,8BAAA;EAA6B,0DAAA;AA6pD7G;;AA5pDA;EAAoO,4CAAA;EAAwC,mBAAA;AAiqD5Q;;AAhqDA;EAAgC,+CAAA;EAA2C,kDAAA;AAqqD3E;;AArqDwH;EAAiB,gDAAA;EAA2C,yBAAA;AA0qDpL;;AAvqDA,8BAAA;AACA;EAAQ,gBAAA;EAAgB,YAAA;AA4qDxB;;AA5qDoC;EAAa,oBAAA;EAAoB,mBAAA;AAirDrE;;AAjrDwF;EAAK,UAAA;EAAU,WAAA;EAAW,iBAAA;AAurDlH;;AArrDA,+BAAA;AACA;EAAiB,aAAA;EAAa,aAAA;EAAa,2CAAA;EAAuC,qCAAA;EAAiC,mBAAA;AA6rDnH;;AA7rDsI;EAAsB,cAAA;AAisD5J;;AAjsD0K;EAAwB,cAAA;EAAc,eAAA;EAAe,kBAAA;AAusD/N;;AAvsDiP;EAAmB,gBAAA;EAAgB,eAAA;EAAe,iBAAA;EAAiB,mBAAA;AA8sDpT;;AA9sDuU;EAAW,eAAA;AAktDlV;;AAltDiW;EAAmB,aAAA;EAAa,yBAAA;EAAyB,eAAA;AAwtD1Z;;AAxtDya;EAAsE,WAAA;AA4tD/e;;AA5tD0f;EAAuE,wBAAA;AAguDjkB;;AAhuDwlB;EAAS,wBAAA;AAouDjmB;;AApuDwnB;EAAoD,aAAA;EAAY,eAAA;EAAe,gDAAA;EAA2C,sCAAA;AA2uDlvB;;AA1uDA;EAAkC,gDAAA;EAA2C,kDAAA;EAA6C,yBAAA;EAAwB,UAAA;AAivDlJ;;AA9uDA,0EAAA;AACA;EAAoB,aAAA;EAAa,uBAAA;EAAuB,8BAAA;EAA8B,SAAA;EAAS,kBAAA;AAsvD/F;;AAtvDiH;EAAqB,YAAA;AA0vDtI;;AA1vDkJ;EAAqB,aAAA;EAAa,qBAAA;EAAqB,QAAA;EAAQ,eAAA;AAiwDjN;;AAjwDgO;EAAwB,SAAA;EAAS,eAAA;EAAe,gBAAA;AAuwDhR;;AAvwDgS;EAAmC,eAAA;EAAe,gBAAA;EAAgB,cAAA;AA6wDlW;;AA7wDgX;EAAuB,eAAA;EAAe,gBAAA;EAAgB,iBAAA;EAAiB,iBAAA;EAAiB,mBAAA;AAqxDxc;;AArxD2d;EAAoB,gBAAA;EAAgB,aAAA;EAAa,mBAAA;EAAmB,8BAAA;EAA8B,SAAA;EAAS,kBAAA;EAAkB,gBAAA;EAAgB,4CAAA;AAgyDxmB;;AAhyDgpB;EAAgC,aAAA;EAAa,mBAAA;EAAmB,QAAA;AAsyDhtB;;AAtyDwtB;EAA8B,YAAA;EAAY,eAAA;AA2yDlwB;;AA3yDixB;EAAmC,eAAA;AA+yDpzB;;AA/yDm0B;EAAa,cAAA;AAmzDh1B;;AAnzD81B;EAAQ,yBAAA;AAuzDt2B;;AAvzD+3B;EAAe,8BAAA;EAA6B,yBAAA;AA4zD36B;;AA5zDo8B;EAAc,8BAAA;EAA6B,yBAAA;AAi0D/+B;;AAj0DwgC;EAAa,gDAAA;EAA2C,kDAAA;AAs0DhkC;;AAt0D6mC;EAAsB,8CAAA;EAAyC,gDAAA;AA20D5qC;;AA30DutC;EAAkB,mBAAA;AA+0DzuC;;AA/0D4vC;EAAkB,aAAA;EAAa,gDAAA;EAA8C,QAAA;AAq1Dz0C;;AAr1Di1C;EAAiB,YAAA;EAAY,YAAA;EAAY,cAAA;EAAc,wCAAA;EAAoC,kBAAA;EAAkB,qCAAA;EAAiC,cAAA;EAAc,cAAA;EAAc,cAAA;EAAc,gBAAA;EAAgB,aAAA;EAAa,mBAAA;EAAmB,eAAA;EAAe,kGAAA;AAs2DxkD;;AAt2DmqD;EAAuB,qCAAA;EAAiC,uCAAA;AA22D3tD;;AA32D8vD;EAAyB,qCAAA;EAAiC,uCAAA;EAAmC,cAAA;AAi3D31D;;AAj3Dy2D;EAAwB,qDAAA;AAq3Dj4D;;AAr3Dk7D;EAAwB,0BAAA;AAy3D18D;;AAz3Do+D;EAA+B,4CAAA;EAAwC,mBAAA;AA83D3iE;;AA73DA;EAAyB;IAAoB,oBAAA;EAk4D3C;EAl4D+D;IAAwC,eAAA;EAq4DvG;EAr4DsH;IAAQ,2BAAA;EAw4D9H;EAx4DyJ;IAAkB,mDAAA;EA24D3K;AACF;AA14DA,+BAAA;AACA;EAAiB,aAAA;EAAa,aAAA;EAAa,2CAAA;EAAuC,qCAAA;EAAiC,mBAAA;AAi5DnH;;AAj5DsI;EAAsB,cAAA;AAq5D5J;;AAr5D0K;EAAwB,cAAA;EAAc,eAAA;EAAe,kBAAA;AA25D/N;;AA35DiP;EAAmB,gBAAA;EAAgB,eAAA;EAAe,iBAAA;EAAiB,mBAAA;AAk6DpT;;AAl6DuU;EAAW,eAAA;AAs6DlV;;AAt6DiW;EAAmB,aAAA;EAAa,yBAAA;EAAyB,eAAA;AA46D1Z;;AA56Dya;EAAsE,WAAA;AAg7D/e;;AAh7D0f;EAAuE,wBAAA;AAo7DjkB;;AAp7DwlB;EAAS,wBAAA;AAw7DjmB;;AAx7DwnB;EAAoD,aAAA;EAAY,eAAA;EAAe,gDAAA;EAA2C,sCAAA;AA+7DlvB;;AA97DA;EAAkC,gDAAA;EAA2C,kDAAA;EAA6C,yBAAA;EAAwB,UAAA;AAq8DlJ;;AAl8DA,iDAAA;AACA;EAAuB,aAAA;EAAa,mDAAA;EAAkD,mBAAA;EAAmB,SAAA;EAAS,kBAAA;AA08DlH;;AA18DoI;EAAmC,aAAA;EAAa,QAAA;EAAQ,mBAAA;AAg9D5L;;AAh9D+M;EAAc,kBAAA;EAAkB,aAAA;EAAa,qBAAA;EAAqB,QAAA;EAAQ,YAAA;EAAY,iBAAA;EAAiB,wCAAA;EAAoC,mBAAA;EAAmB,qCAAA;AA49D7W;;AA59D8Y;EAAa,gBAAA;EAAgB,gBAAA;EAAgB,sBAAA;EAAqB,yBAAA;EAAyB,cAAA;AAo+Dze;;AAp+Duf;EAA4B,YAAA;EAAY,eAAA;EAAe,iBAAA;EAAiB,gBAAA;EAAgB,cAAA;EAAc,uBAAA;AA6+D7lB;;AA7+DmnB;EAAwB,aAAA;EAAa,uBAAA;EAAuB,8BAAA;EAA8B,SAAA;EAAS,mBAAA;EAAmB,gBAAA;EAAgB,4CAAA;AAu/DzvB;;AAv/DiyB;EAA0B,SAAA;EAAS,gBAAA;EAAgB,iBAAA;EAAiB,iBAAA;EAAiB,mBAAA;AA+/Dt3B;;AA//Dy4B;EAAgC,yBAAA;AAmgEz6B;;AAngEk8B;EAAkB,kBAAA;EAAkB,OAAA;EAAO,WAAA;EAAW,WAAA;EAAW,eAAA;EAAe,kBAAA;EAAkB,cAAA;EAAc,cAAA;EAAc,UAAA;EAAU,oBAAA;EAAoB,2FAAA;EAAiF,cAAA;AAkhE/qC;;AAlhE6rC;EAAU,4BAAA;EAA2B,0HAAA;AAuhEluC;;AAvhEo1C;EAAsK,0BAAA;AA2hE1/C;;AA3hEohD;EAAsB,UAAA;AA+hE1iD;;AA/hEojD;EAAe,iBAAA;AAmiEnkD;;AAniEolD;EAAyB;IAAuB,+BAAA;EAwiEloD;EAxiEiqD;IAAc,iBAAA;IAAiB,WAAA;EA4iEhsD;EA5iE2sD;IAAY,cAAA;IAAc,WAAA;EAgjEruD;EAhjEgvD;IAAoC,cAAA;IAAc,WAAA;EAojElyD;EApjE6yD;IAAwB,eAAA;EAujEr0D;EAvjEo1D;IAAgC,2BAAA;EA0jEp3D;AACF;AAzjEA,+BAAA;AACA;EAAiB,aAAA;EAAa,aAAA;EAAa,2CAAA;EAAuC,qCAAA;EAAiC,mBAAA;AAgkEnH;;AAhkEsI;EAAsB,cAAA;AAokE5J;;AApkE0K;EAAwB,cAAA;EAAc,eAAA;EAAe,kBAAA;AA0kE/N;;AA1kEiP;EAAmB,gBAAA;EAAgB,eAAA;EAAe,iBAAA;EAAiB,mBAAA;AAilEpT;;AAjlEuU;EAAW,eAAA;AAqlElV;;AArlEiW;EAAmB,aAAA;EAAa,yBAAA;EAAyB,eAAA;AA2lE1Z;;AA3lEya;EAAsE,WAAA;AA+lE/e;;AA/lE0f;EAAuE,wBAAA;AAmmEjkB;;AAnmEwlB;EAAS,wBAAA;AAumEjmB;;AAvmEwnB;EAAoD,aAAA;EAAY,eAAA;EAAe,gDAAA;EAA2C,sCAAA;AA8mElvB;;AA7mEA;EAAkC,gDAAA;EAA2C,kDAAA;EAA6C,yBAAA;EAAwB,UAAA;AAonElJ;;AAjnEA;;8EAAA;AAIA;EACE,wBAAA;EACA,mFAAA;EACA,2BAAA;EACA,wCAAA;EACA,qBAAA;EACA,6BAAA;EACA,qBAAA;EACA,2BAAA;EACA,kCAAA;EACA,oBAAA;EACA,2BAAA;EACA,2BAAA;EACA,sBAAA;AAmnEF;;AAhnEA;EACE,4BAAA;AAmnEF;;AAhnEA;EACE,yBAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,uBAAA;EACA,wBAAA;EACA,2BAAA;EACA,wBAAA;EACA,mDAAA;EACA,8BAAA;EACA,sDAAA;EACA,4BAAA;EACA,8BAAA;AAmnEF;;AAhnEA;EACE,yBAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,oBAAA;EACA,sBAAA;EACA,iCAAA;EACA,sBAAA;EACA,0BAAA;EACA,oBAAA;EACA,4BAAA;AAmnEF;;AAhnEA;EACE,iCAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,wBAAA;EACA,8BAAA;EACA,4BAAA;EACA,8BAAA;EACA,yCAAA;EACA,oBAAA;EACA,uCAAA;EACA,8BAAA;EACA,iGAAA;EACA,mDAAA;EACA,wDAAA;EACA,4CAAA;AAmnEF;;AAhnEA;EACE,yBAAA;EACA,uBAAA;EACA,wBAAA;EACA,kCAAA;EACA,oBAAA;AAmnEF;;AAhnEA;EACE,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,8BAAA;EACA,yBAAA;EACA,0BAAA;EACA,qEAAA;AAmnEF;AAjnEE;EACE,mDAAA;AAmnEJ;;AA/mEA;EACE,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,4BAAA;EACA,6BAAA;AAknEF;;AA/mEA;EACE,0BAAA;EACA,4BAAA;EACA,yBAAA;AAknEF;;AA/mEA;EACE,yBAAA;EACA,wBAAA;EACA,6CAAA;EACA,+BAAA;EACA,oBAAA;EACA,4BAAA;EACA,sBAAA;AAknEF;;AA/mEA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,2BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;EACA,kCAAA;EACA,8BAAA;EACA,8BAAA;EACA,0BAAA;EACA,2BAAA;EACA,eAAA;EACA,yBAAA;AAknEF;;AA/mEA;EACE,kCAAA;EACA,qDAAA;EACA,yBAAA;AAknEF;AAhnEE;EACE,gDAAA;AAknEJ;;AA9mEA;EACE,8BAAA;EACA,uBAAA;EACA,sBAAA;EACA,2BAAA;AAinEF;AA/mEE;EACE,8BAAA;EACA,2BAAA;AAinEJ;AA9mEE;EACE,YAAA;EACA,mBAAA;AAgnEJ;;AA5mEA;EACE,yBAAA;EACA,2BAAA;EACA,qBAAA;AA+mEF;;AA5mEA;EACE,0BAAA;EACA,mCAAA;EACA,2BAAA;EACA,2BAAA;EACA,oBAAA;EACA,sCAAA;AA+mEF;;AA5mEA;EACE,0BAAA;EACA,4BAAA;EACA,0BAAA;EACA,uCAAA;AA+mEF;;AA5mEA;EACE,wBAAA;EACA,oEAAA;EACA,8BAAA;EACA,mBAAA;EACA,8BAAA;AA+mEF;;AA5mEA;EACE,8BAAA;EACA,wBAAA;EACA,8BAAA;EACA,mBAAA;AA+mEF;;AA5mEA;EACE,+BAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,6BAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EACA,gDAAA;AA+mEF;;AA5mEA;EACE,0BAAA;EACA,4BAAA;EACA,2BAAA;EACA,yBAAA;EACA,kCAAA;AA+mEF;;AA5mEA;EACE,4BAAA;EACA,wBAAA;EACA,8BAAA;EACA,6BAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,uBAAA;EACA,+CAAA;EACA,0CAAA;EACA,8BAAA;AA+mEF;;AA5mEA;EACE,uBAAA;EACA,2BAAA;EACA,8BAAA;AA+mEF;;AA5mEA;EACE,uBAAA;EACA,2BAAA;EACA,6BAAA;EACA,+BAAA;AA+mEF;;AA5mEA;EACE,wBAAA;EACA,8BAAA;EACA,yCAAA;EACA,oBAAA;EACA,8BAAA;EACA,4BAAA;EACA,uDAAA;AA+mEF;;AA5mEA;EACE,0BAAA;EACA,uBAAA;EACA,yBAAA;EACA,oBAAA;EACA,6BAAA;EACA,qDAAA;EACA,8BAAA;EACA,8BAAA;EACA,yBAAA;EACA,2BAAA;EACA,0BAAA;EACA,4BAAA;AA+mEF;;AA5mEA;EACE,yBAAA;EACA,wBAAA;EACA,8BAAA;EACA,oBAAA;EACA,oBAAA;AA+mEF;;AA5mEA;EACE,gEAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;AA+mEF;;AA5mEA;EACE,2BAAA;EACA,oBAAA;EACA,wBAAA;EACA,iCAAA;EACA,8BAAA;EACA,sBAAA;EACA,0BAAA;EACA,uBAAA;EACA,uBAAA;EACA,0CAAA;EACA,4BAAA;AA+mEF;;AA5mEA;EACE,2BAAA;EACA,sBAAA;EACA,yBAAA;EACA,wBAAA;EACA,iCAAA;EACA,2BAAA;EACA,wBAAA;EACA,8BAAA;EACA,mDAAA;EACA,8BAAA;EACA,sDAAA;EACA,4BAAA;AA+mEF;;AA5mEA;EACE,0BAAA;EACA,2BAAA;EACA,0BAAA;AA+mEF;;AA5mEA;EACE,0BAAA;EACA,4BAAA;EACA,uCAAA;EACA,2BAAA;AA+mEF;;AA5mEA;EACE,wBAAA;EACA,2DAAA;EACA,mBAAA;EACA,2BAAA;EACA,qBAAA;EACA,kCAAA;EACA,oBAAA;AA+mEF;;AA5mEA;EACE,2BAAA;EACA,sDAAA;EACA,8BAAA;EACA,kCAAA;EACA,yBAAA;EACA,0BAAA;EACA,2BAAA;AA+mEF;;AA5mEA;EACE,gDAAA;EACA,gDAAA;EACA,yBAAA;EACA,2BAAA;AA+mEF;;AA5mEA;EACE,6BAAA;EACA,gDAAA;EACA,qDAAA;EACA,8BAAA;EACA,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,8BAAA;AA+mEF;;AA5mEA;EACE,yBAAA;EACA,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,0BAAA;EACA,iCAAA;AA+mEF;;AA5mEA;EACE,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2BAAA;AA+mEF;;AA5mEA;EACE,wBAAA;EACA,2DAAA;EACA,mBAAA;AA+mEF;;AA5mEA;EACE,uBAAA;EACA,8BAAA;EACA,2BAAA;EACA,2BAAA;AA+mEF;;AA5mEA;EACE,wBAAA;EACA,2DAAA;EACA,mBAAA;EACA,sBAAA;EACA,0BAAA;AA+mEF;;AA5mEA;EACE,uBAAA;EACA,8BAAA;EACA,2BAAA;EACA,0BAAA;AA+mEF;;AA5mEA;EACE,2BAAA;EACA,8BAAA;AA+mEF;;AA5mEA;EACE,wBAAA;EACA,sDAAA;EACA,oBAAA;EACA,8BAAA;AA+mEF;;AA5mEA;EACE,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,2BAAA;EACA,2BAAA;EACA,0BAAA;AA+mEF;;AA5mEA;EACE;IACE,gDAAA;IACA,wBAAA;EA+mEF;EA7mEA;IACE,wBAAA;IACA,iCAAA;IACA,oBAAA;EA+mEF;EA7mEA;IACE,4BAAA;IACA,yBAAA;IACA,sBAAA;EA+mEF;EA7mEA;IACE,4BAAA;IACA,yBAAA;IACA,2BAAA;IACA,2BAAA;IACA,sBAAA;EA+mEF;EA7mEA;IACE,4BAAA;IACA,yBAAA;IACA,sBAAA;EA+mEF;AACF;AA5mEA,mEAAA;AACA;EAAqB,wBAAA;EAAuB,8BAAA;EAA6B,yCAAA;EAAwC,oBAAA;EAAmB,uBAAA;AAmnEpI;;AAlnEA;EAAqB,cAAA;EAAc,YAAA;EAAY,uBAAA;AAwnE/C;;AAvnEA;EAAkB,cAAA;EAAc,WAAA;EAAW,YAAA;EAAY,oBAAA;EAAoB,mBAAA;EAAmB,uBAAA;EAAuB,uBAAA;EAAuB,cAAA;EAAc,yBAAA;EAAyB,8BAAA;EAA6B,eAAA;EAAe,0BAAA;EAAyB,UAAA;EAAU,kBAAA;AAwoElQ;;AAvoEA;EAAwD,mBAAA;EAAmB,WAAA;EAAW,mBAAA;AA6oEtF;;AA5oEA;EAA0B,wBAAA;AAgpE1B;;AA9oEA;EAAmB,+CAAA;EAA0C,oDAAA;EAA+C,yBAAA;EAAwB,2BAAA;AAqpEpI;;AAppEA;EAAsB,oDAAA;EAA+C,2BAAA;EAA0B,6BAAA;AA0pE/F;;AAzpEA;EAAoB,YAAA;EAAY,gBAAA;AA8pEhC;;AA7pEA;EAAqC,WAAA;AAiqErC;;AAhqEA;EAAmB,oBAAA;EAAmB,0BAAA;EAAyB,4BAAA;EAA2B,mBAAA;EAAmB,kBAAA;AAwqE7G;;AAvqEA;EAAyB;IAAkB,0BAAA;EA4qEzC;EA5qEmE;IAAoB,WAAA;IAAW,YAAA;EAgrElG;EAhrE8G;IAAmB,0BAAA;EAmrEjI;AACF;AAjrEA,6DAAA;AACA;EAA2D,kCAAA;EAAiC,iDAAA;EAA6C,yBAAA;AAsrEzI;;AArrEA;EAAiE,+CAAA;EAA2C,kDAAA;EAA6C,yBAAA;AA2rEzJ;;AA1rEA;EAAkE,gDAAA;EAA2C,uCAAA;EAAsC,yBAAA;EAAwB,2BAAA;AAisE3K;;AAhsEA;EAAwB,gDAAA;EAA2C,kDAAA;EAA6C,yBAAA;AAssEhH;;AArsEA;EAAoB,8BAAA;AAysEpB;;AAxsEA;EAAqB,aAAA;EAAa,0BAAA;EAA0B,QAAA;EAAQ,eAAA;AA+sEpE;;AA9sEA;EAA0B,WAAA;AAktE1B;;AAjtEA;EAAiB,eAAA;AAqtEjB;;AAptEA;EAAiB,oBAAA;AAwtEjB;;AAvtEA;EAAgB,gDAAA;EAA2C,iDAAA;EAA6C,yBAAA;AA6tExG;;AA5tEA;EAAsB,oDAAA;AAguEtB;;AA9tEA;EAA2B,wBAAA;AAkuE3B;;AAjuEA;EAAiD;IAAoB,8BAAA;EAsuEnE;AACF;AAruEA,mFAAA;AACA;EAAsB,aAAA;EAAa,gDAAA;EAA8C,QAAA;EAAQ,WAAA;AA2uEzF;;AA1uEA;EAA2B,WAAA;EAAW,YAAA;AA+uEtC;;AA9uEA,uDAAA;AACA;EAA0B,cAAA;EAAc,WAAA;EAAW,eAAA;EAAe,YAAA;EAAY,2BAAA;EAA0B,sDAAA;EAAiD,mBAAA;EAAmB,iDAAA;EAA4C,yBAAA;EAAwB,eAAA;EAAe,gBAAA;EAAgB,eAAA;EAAe,gDAAA;AA8vE9R;;AA7vEA;EAAgC,gDAAA;EAA2C,gCAAA;AAkwE3E;;AAjwEA;EAA+C,gDAAA;EAA2C,gCAAA;AAswE1F;;AArwEA;EAAwC,4CAAA;EAAwC,mBAAA;AA0wEhF;;AAzwEA;EAAkC,wBAAA;AA6wElC;;AA1wEA;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,kCAAA;EACA,yCAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;EACA,oBAAA;EACA,gBAAA;AA6wEF;;AA1wEA,8EAAA;AACA;EACE,0BAAA;EACA,wBAAA;EACA,aAAA;EACA,uBAAA;EACA,2BAAA;EACA,wCAAA;EACA,uBAAA;EACA,2BAAA;EACA,kDAAA;EACA,8BAAA;EACA,yDAAA;AA6wEF;AA3wEE;EACE,wBAAA;EACA,iCAAA;EACA,mBAAA;AA6wEJ;AA1wEE;EACE,sBAAA;EACA,wBAAA;EACA,8BAAA;EACA,mBAAA;EACA,2BAAA;EACA,6BAAA;EACA,oBAAA;EACA,6BAAA;EACA,kCAAA;EACA,yBAAA;EACA,qDAAA;EACA,0BAAA;EACA,4CAAA;AA4wEJ;AA1wEI;EACE,gDAAA;AA4wEN;AAzwEI;EACE,yBAAA;EACA,sDAAA;EACA,qCAAA;EACA,0BAAA;EACA,4BAAA;AA2wEN;AAzwEM;EACE,8CAAA;AA2wER;;AArwEA,oBAAA;AACA;EACE,eAAA;EACA,QAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;EACA,0BAAA;AAwwEF;;AAtwEA;EAA2B,aAAA;AA0wE3B;;AAzwEA;EACE,uBAAA;EACA,mBAAA;EACA,uCAAA;EACA,mBAAA;EACA,aAAA;EACA,8CAAA;AA4wEF;;AA1wEA;EAAiB,eAAA;EAAiB,eAAA;AA+wElC;;AA9wEA;EAAgB,gBAAA;EAAkB,eAAA;EAAiB,iBAAA;EAAmB,mBAAA;AAqxEtE;;AApxEA;EAAgB,aAAA;EAAe,8BAAA;EAAgC,uBAAA;EAAyB,kBAAA;AA2xExF;;AA1xEA;EAAe,gBAAA;EAAkB,YAAA;EAAc,eAAA;EAAiB,mBAAA;EAAqB,eAAA;EAAiB,cAAA;EAAgB,UAAA;AAoyEtH;;AAnyEA;EAAqB,kBAAA;AAuyErB;;AAtyEA;EAAqB,aAAA;EAAe,yBAAA;EAA2B,QAAA;EAAU,gBAAA;AA6yEzE;;AA5yEA;EAAe,aAAA;EAAe,QAAA;EAAU,eAAA;AAkzExC;;AAjzEA;EACE,aAAA;EACA,QAAA;EACA,uBAAA;EACA,iBAAA;EACA,+BAAA;EACA,mBAAA;EACA,oCAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gDAAA;AAozEF;;AAlzEA;EAAmB,uBAAA;EAAyB,uCAAA;AAuzE5C;;AAtzEA;EAAmB,4BAAA;EAA8B,eAAA;AA2zEjD;;AA1zEA;EACE,kBAAA;EACA,mCAAA;EACA,yCAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AA6zEF;;AA1zEA;EACE,kBAAA;EACA,qCAAA;EACA,2CAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AA6zEF;;AA1zEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AA6zEF;;AA1zEA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8CAAA;EACA,mBAAA;AA6zEF;;AA1zEA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA6zEF;;AA1zEA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AA6zEF;;AA1zEA;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,cAAA;AA6zEF;;AA1zEA;EACE,gBAAA;EACA,oBAAA;AA6zEF;;AA1zEA;EACE,uBAAA;EACA,8BAAA;EACA,8BAAA;EACA,oCAAA;EACA,4BAAA;EACA,2BAAA;EACA,yBAAA;EACA,0BAAA;EACA,kBAAA;AA6zEF;;AA1zEA;EACE,6BAAA;EACA,yDAAA;EACA,4BAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AA6zEF;;AA1zEA;EACE,kBAAA;EACA,qCAAA;EACA,2CAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AA6zEF;;AA1zEA;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,QAAA;AA6zEF;;AA1zEA;EACE,mBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AA6zEF;;AA1zEA;EACE,cAAA;EACA,mBAAA;EACA,yBAAA;AA6zEF;;AA1zEA;EACE,mBAAA;EACA,cAAA;EACA,YAAA;AA6zEF;;AA1zEA,gEAAA;AACA;EACE,gBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,4CAAA;AA6zEF;AA3zEE;EACE,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,sFAAA;EACA,wCAAA;EACA,6CAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,4BAAA;AA6zEJ;AA3zEI;EACE,sFAAA;AA6zEN;AAzzEE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;AA2zEJ;AAxzEE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,iCAAA;AA0zEJ;AAxzEI;EACE,mBAAA;AA0zEN;AAvzEI;EACE,kCAAA;AAyzEN;AArzEE;EACE,aAAA;EACA,sBAAA;AAuzEJ;AApzEE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AAszEJ;AAnzEE;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AAqzEJ;AAlzEE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AAozEJ;AAjzEE;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAmzEJ;AAjzEI;EACE,qCAAA;AAmzEN;AA/yEE;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,qDAAA;AAizEJ;AA/yEI;EACE,mBAAA;EACA,2BAAA;AAizEN;AA9yEI;EACE,YAAA;EACA,mBAAA;AAgzEN;AA5yEE;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,sBAAA;EACA,kBAAA;EACA,uCAAA;AA8yEJ;;AA1yEA;EACE;IAAO,2BAAA;IAA6B,UAAA;EA+yEpC;EA9yEA;IAAO,wBAAA;IAA6B,UAAA;EAkzEpC;AACF;AAhzEA;EACE;IAAK,yBAAA;EAmzEL;AACF;AAjzEA;EACE;IACE,YAAA;EAmzEF;EAjzEE;IACE,mBAAA;IACA,sBAAA;IACA,oBAAA;IACA,aAAA;IACA,YAAA;EAmzEJ;EAhzEE;IAEE,WAAA;IACA,YAAA;EAizEJ;AACF;AA7yEA;EACE,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;AA+yEF","sourcesContent":["\n:root{--bg:#EFF0EC;--surface:#F7F5F1;--white:#fff;--text:#13231D;--muted:#6C7771;--border:rgba(16,25,21,.10);--primary:#82B194;--primary-dark:#6F9A80;--soft:rgba(130,177,148,.13);--reserved:#5F8F70;--gold:#D6A640;--gold-soft:#F8F4E7;--shadow:0 12px 28px rgba(18,34,28,.06);}\n*{box-sizing:border-box}body{margin:0;background:var(--bg);font-family:Sora,system-ui,sans-serif;color:var(--text)}button,input,select{font:inherit}.shell{width:min(calc(100vw - 28px),1480px);margin:8px auto;display:grid;grid-template-columns:216px minmax(0,1fr);gap:22px}.sidebar{background:var(--surface);border:1px solid rgba(16,25,21,.05);border-radius:26px;padding:20px 14px;min-height:820px}.brand img{width:126px;margin:6px 6px 24px}.side-title{font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:#83908A;font-weight:800;margin:20px 10px 8px}.nav{display:grid;gap:7px}.nav a{color:#5D6963;text-decoration:none;padding:12px 14px;border-radius:14px;font-size:13px;font-weight:600}.nav a.active{background:var(--soft);border:1px solid rgba(130,177,148,.34);color:var(--text);font-weight:700}.main{min-width:0}.topbar{height:44px;display:flex;align-items:center;justify-content:flex-end;padding:0 8px;margin-bottom:6px;color:#5f6b65;font-size:13px}.workspace{background:var(--surface);border:1px solid rgba(16,25,21,.05);border-radius:28px;padding:22px 24px 24px;box-shadow:var(--shadow)}.head{display:flex;justify-content:space-between;gap:24px;align-items:flex-start;margin-bottom:14px}.head h1{margin:0;font-size:28px;letter-spacing:-.04em}.head p{margin:6px 0 0;color:var(--muted);font-size:13px;line-height:1.45;max-width:760px}.back{border:1px solid var(--border);background:transparent;border-radius:14px;padding:10px 15px;font-weight:700;color:var(--text);text-decoration:none;font-size:13px}.tabs{display:inline-flex;background:rgba(255,255,255,.58);border:1px solid var(--border);padding:4px;border-radius:15px;margin-bottom:18px}.editor-tabs{display:flex;width:100%;margin:0 0 18px}.editor-tabs .tab{flex:1;padding:9px 8px;font-size:11px}.editor-panel{display:none}.editor-panel.active{display:block}.tab{border:0;background:transparent;border-radius:11px;padding:10px 15px;color:var(--muted);font-weight:700;cursor:pointer}.tab.active{background:var(--white);color:var(--text);box-shadow:0 3px 10px rgba(18,34,28,.06)}.panel{display:none}.panel.active{display:block}.calendar-layout{display:grid;grid-template-columns:minmax(0,1fr) 300px;gap:14px;align-items:start}.calendar-card,.editor-card{background:rgba(255,255,255,.58);border:1px solid var(--border);border-radius:20px}.calendar-card{padding:14px}.calendar-toolbar{display:flex;align-items:flex-start;justify-content:space-between;gap:12px;margin-bottom:10px}.calendar-toolbar h2{font-size:15px;margin:0}.calendar-toolbar p{font-size:11px;color:var(--muted);margin:4px 0 0;line-height:1.45}.legend{display:flex;gap:12px;flex-wrap:wrap;font-size:10px;color:var(--muted);font-weight:600}.dot{width:8px;height:8px;border-radius:50%;display:inline-block;margin-right:5px}.dot.available{background:var(--primary)}.dot.reserved{background:var(--reserved)}.week-grid{display:grid;touch-action:none;grid-template-columns:56px repeat(7,minmax(82px,1fr));position:relative;border:1px solid var(--border);border-radius:14px;overflow:hidden;background:rgba(255,255,255,.7);user-select:none}.corner{grid-column:1;grid-row:1;background:rgba(239,240,236,.55);border-right:1px solid var(--border);border-bottom:1px solid var(--border)}.day-head{display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:800;color:#617069;background:rgba(239,240,236,.55);border-right:1px solid var(--border);border-bottom:1px solid var(--border);cursor:pointer}.day-head:last-of-type{border-right:0}.day-head.active{background:var(--soft);color:#2F4A3F}.time-label{display:flex;align-items:flex-start;justify-content:center;padding-top:2px;font-size:9px;color:#89938E;border-right:1px solid var(--border);border-bottom:1px solid rgba(16,25,21,.045);z-index:2}.cell{border-right:1px solid rgba(16,25,21,.055);border-bottom:0;cursor:crosshair;position:relative}.cell.half-hour{border-bottom:1px solid rgba(16,25,21,.045)}.cell:hover{background:rgba(130,177,148,.07)}.cell.painting{background:rgba(130,177,148,.20)}.agenda-slot{position:relative;margin:2px 3px;border-radius:8px;background:rgba(130,177,148,.28);border:1px solid rgba(111,154,128,.42);display:flex;align-items:flex-start;justify-content:center;padding:5px 4px;font-size:9px;line-height:1.3;font-weight:800;color:#315044;z-index:5;cursor:pointer;overflow:hidden}.agenda-slot.selected{outline:2px solid rgba(19,35,29,.34);outline-offset:-2px}.agenda-slot.reserved{background:rgba(95,143,112,.26);border-color:rgba(95,143,112,.42);color:#2d4838;z-index:8}.agenda-slot .slot-label{pointer-events:none;padding-right:14px}.slot-menu-trigger{position:absolute;right:2px;top:2px;width:18px;height:18px;border:0;border-radius:7px;background:rgba(255,255,255,.86);color:#52625a;font-weight:900;font-size:14px;line-height:16px;padding:0;display:none;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 1px 4px rgba(18,34,28,.08)}.agenda-slot:hover .slot-menu-trigger,.agenda-slot.selected .slot-menu-trigger{display:flex}.context-menu{position:fixed;z-index:1000;display:none;min-width:168px;padding:6px;background:#fff;border:1px solid var(--border);border-radius:12px;box-shadow:0 12px 30px rgba(18,34,28,.14)}.context-menu.open{display:block}.selection-note strong{color:var(--text)}.editor-card{padding:14px;position:sticky;top:14px}.editor-card h2{font-size:15px;margin:0 0 5px}.editor-card .lead{font-size:11px;line-height:1.45;color:var(--muted);margin:0 0 12px}.field{margin-bottom:10px}.field label{display:block;font-size:10px;font-weight:800;color:#6D7872;margin:0 0 7px;letter-spacing:.02em}.control{width:100%;height:42px;border:1px solid var(--border);background:rgba(255,255,255,.82);border-radius:12px;padding:0 12px;color:var(--text);outline:none}.time-picker{position:relative}.time-picker-btn{width:100%;height:42px;border:1px solid var(--border);background:rgba(255,255,255,.82);border-radius:12px;padding:0 12px;color:var(--text);font:inherit;font-weight:500;display:flex;align-items:center;justify-content:center;gap:6px;cursor:pointer}.time-picker-btn:hover,.time-picker.open .time-picker-btn{border-color:rgba(130,177,148,.58);background:rgba(130,177,148,.07)}.time-picker-popover{display:none;position:absolute;z-index:1200;top:46px;left:0;min-width:164px;padding:8px;background:#fff;border:1px solid var(--border);border-radius:12px;box-shadow:0 12px 30px rgba(18,34,28,.14)}.time-picker.open .time-picker-popover{display:grid;grid-template-columns:1fr 1fr;gap:6px}.time-list{max-height:220px;overflow:auto;display:grid;gap:3px}.time-option{height:30px;border:0;border-radius:8px;background:transparent;color:var(--text);font-size:12px;font-weight:600;cursor:pointer}.time-option:hover{background:var(--soft)}.time-option.selected{background:var(--soft);color:#294439;box-shadow:inset 0 0 0 1px rgba(130,177,148,.32)}.time-picker-value{font-variant-numeric:tabular-nums}.day-multi{position:relative}.day-multi-btn{width:100%;height:42px;border:1px solid var(--border);background:rgba(255,255,255,.82);border-radius:12px;padding:0 12px;color:var(--text);display:flex;align-items:center;justify-content:space-between;font-weight:500;cursor:pointer}.day-multi.open .day-multi-btn{border-color:rgba(130,177,148,.58);background:rgba(130,177,148,.07)}.day-multi-popover{display:none;position:absolute;z-index:1100;top:46px;left:0;right:0;padding:8px;background:#fff;border:1px solid var(--border);border-radius:12px;box-shadow:0 12px 30px rgba(18,34,28,.14)}.day-multi.open .day-multi-popover{display:grid;gap:3px}.day-multi-option{display:flex;align-items:center;gap:8px;padding:7px 8px;border-radius:8px;font-size:11px;font-weight:600;color:#5f6b65;cursor:pointer}.day-multi-option:hover{background:var(--soft)}.day-multi-option input{width:15px;height:15px;accent-color:var(--primary)}.pair{display:grid;grid-template-columns:1fr 1fr;gap:8px}.btn{height:42px;border-radius:12px;padding:0 15px;border:1px solid transparent;font-weight:800;font-size:12px;cursor:pointer}.btn.primary{background:var(--primary);color:#fff}.btn.primary:hover{background:var(--primary-dark)}.btn.secondary{background:transparent;border-color:rgba(19,35,29,.18);color:var(--text)}.btn.ghost{height:36px;background:transparent;border-color:var(--border);color:#68746e}.btn.danger{height:36px;background:rgba(159,169,165,.08);border-color:rgba(159,169,165,.66);color:#56635D}.btn-row{display:flex;gap:8px;flex-wrap:wrap}.divider{height:1px;background:var(--border);margin:13px 0}.selection-note{padding:8px 10px;background:rgba(130,177,148,.08);border:1px solid rgba(130,177,148,.20);border-radius:12px;font-size:10px;line-height:1.5;color:#5d6d65;margin-bottom:10px}.small{font-size:10px;color:var(--muted);line-height:1.5}.footer-actions{display:flex;justify-content:flex-end;gap:10px;border-top:1px solid var(--border);padding-top:18px;margin-top:18px}.toast{display:none;margin-top:12px;padding:10px 12px;border-radius:11px;background:rgba(130,177,148,.12);color:#355044;font-size:11px;font-weight:700}.toast.show{display:block}.switchline{display:flex;align-items:center;gap:9px;margin:14px 0;font-size:12px}.checkbox{width:18px;height:18px;accent-color:var(--primary)}\n.calendar-nav{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:14px;flex-wrap:wrap}.period-nav,.view-switch{display:flex;align-items:center;gap:6px}.period-label{min-width:172px;text-align:center;font-size:12px;font-weight:800;color:#44564e}.nav-mini,.view-btn{height:34px;border:1px solid var(--border);background:rgba(255,255,255,.72);border-radius:10px;padding:0 10px;color:#52625a;font-size:11px;font-weight:800;cursor:pointer}.nav-mini:hover,.view-btn:hover{background:var(--soft);border-color:rgba(130,177,148,.34)}.view-switch{padding:3px;background:rgba(255,255,255,.5);border:1px solid var(--border);border-radius:12px}.view-btn{border:0;background:transparent;height:30px}.view-btn.active{background:var(--soft);color:#294439;box-shadow:inset 0 0 0 1px rgba(130,177,148,.28)}.calendar-view{display:none}.calendar-view.active{display:block}.day-view{border:1px solid var(--border);border-radius:14px;overflow:hidden;background:rgba(255,255,255,.7);min-height:520px}.day-view-head{height:44px;display:flex;align-items:center;justify-content:center;background:rgba(239,240,236,.55);border-bottom:1px solid var(--border);font-size:11px;font-weight:800}.day-lane{position:relative;padding:18px 22px 18px 74px;min-height:475px;background:repeating-linear-gradient(to bottom,transparent 0,transparent 38px,rgba(16,25,21,.055) 39px)}.day-time{position:absolute;left:18px;font-size:9px;color:#89938E}.day-slot{position:absolute;left:76px;right:24px;border-radius:10px;padding:8px 10px;font-size:10px;font-weight:800}.day-slot.available{background:rgba(130,177,148,.20);border:1px solid rgba(111,154,128,.36);color:#315044}.month-grid{display:grid;grid-template-columns:repeat(7,1fr);border:1px solid var(--border);border-radius:14px;overflow:hidden;background:rgba(255,255,255,.7)}.month-head{padding:10px 6px;text-align:center;background:rgba(239,240,236,.55);border-right:1px solid var(--border);border-bottom:1px solid var(--border);font-size:9px;font-weight:800;color:#617069}.month-day{min-height:86px;padding:8px;border-right:1px solid rgba(16,25,21,.055);border-bottom:1px solid rgba(16,25,21,.055);cursor:pointer}.month-day:hover{background:rgba(130,177,148,.06)}.month-day.muted{opacity:.38}.month-num{font-size:10px;font-weight:800}.month-status{display:flex;gap:4px;margin-top:9px;flex-wrap:wrap}.month-pill{height:7px;border-radius:99px;min-width:28px;background:rgba(130,177,148,.35)}.month-pill.reserved{background:rgba(95,143,112,.52)}.replicate-btn{width:100%;margin-top:14px}.replicate-backdrop{position:fixed;inset:0;background:rgba(19,35,29,.28);display:none;align-items:center;justify-content:center;z-index:2000;padding:20px}.replicate-backdrop.open{display:flex}.modal-card{width:min(460px,100%);background:#F7F5F1;border:1px solid rgba(16,25,21,.10);border-radius:20px;padding:22px;box-shadow:0 24px 60px rgba(18,34,28,.18)}.modal-card h3{margin:0 0 6px;font-size:18px}.modal-card p{margin:0 0 18px;font-size:11px;line-height:1.55;color:var(--muted)}.replicate-actions{display:flex;justify-content:flex-end;gap:8px;margin-top:18px}.radio-stack{display:grid;gap:8px;margin-top:8px}.radio-row{display:flex;gap:9px;align-items:flex-start;padding:9px 10px;border:1px solid var(--border);border-radius:11px;background:rgba(255,255,255,.6);font-size:11px;color:#56645e}.radio-row input{accent-color:var(--primary);margin-top:2px}.custom-range{display:none;grid-template-columns:1fr 1fr;gap:8px;margin-top:10px}.custom-range.show{display:grid}.system-select{appearance:none;background:rgba(255,255,255,.82) url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='%2352625a' stroke-width='2'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E\") no-repeat right 12px center;padding-right:34px}.replicate-note{padding:10px 11px;background:rgba(130,177,148,.08);border:1px solid rgba(130,177,148,.18);border-radius:11px;font-size:10px;line-height:1.5;color:#5d6d65;margin-top:12px}.btn.primary{box-shadow:0 5px 14px rgba(130,177,148,.18)}\n@media (max-width:1180px){.calendar-layout{grid-template-columns:1fr}.editor-card{position:static}.week-grid{grid-template-columns:48px repeat(7,minmax(68px,1fr))}}@media (max-width:850px){.shell{grid-template-columns:1fr}.sidebar{display:none}.workspace{padding:20px}.calendar-card{overflow:auto}.week-grid{min-width:780px}.head{display:block}.back{display:inline-block;margin-top:12px}}\n\n/* optimización de densidad y selección multidía */\n.workspace{padding:24px}.head{margin-bottom:16px}.calendar-layout{grid-template-columns:minmax(0,1fr) 292px;gap:14px}.calendar-card{padding:14px}.editor-card{padding:14px;border-radius:18px}.calendar-card{border-radius:18px}.editor-tabs{margin-bottom:14px}.editor-tabs .tab{padding:8px 6px}.editor-card h2{font-size:14px}.editor-card .lead{margin-bottom:13px;line-height:1.4}.field{margin-bottom:9px}.field label{margin-bottom:5px;font-size:9px}.control,.time-picker-btn,.day-multi-btn{height:38px;border-radius:11px}.btn{height:38px;border-radius:11px}.divider{margin:13px 0}.selection-note{padding:9px 10px}.footer-actions{margin-top:14px}.replicate-btn{margin-top:10px}.small{margin-top:5px;line-height:1.4}.calendar-toolbar{margin-bottom:10px}.calendar-toolbar p{line-height:1.35}.day-multi-popover{padding:8px;gap:6px}.day-multi.open .day-multi-popover{display:flex;flex-wrap:wrap}.day-multi-option{position:relative;justify-content:center;padding:7px 9px;min-width:72px;border:1px solid var(--border);background:rgba(255,255,255,.72);border-radius:999px;color:#5f6b65}.day-multi-option:hover{background:var(--soft);border-color:rgba(130,177,148,.32)}.day-multi-option input{position:absolute;opacity:0;pointer-events:none}.day-multi-option:has(input:checked){background:var(--soft);border-color:rgba(130,177,148,.48);color:#294439}.agenda-slot{border-radius:7px}.tab{font-size:11px}.nav a{padding:11px 14px}\n\n/* optimización visual y hoy */\n.day-head{min-height:42px;flex-direction:column;gap:1px;line-height:1.1}\n.day-head .dow{font-size:10px;font-weight:800}\n.day-head .date{font-size:9px;font-weight:600;color:#7b8781}\n.day-head.today{background:var(--gold-soft);color:#7A5710;box-shadow:inset 0 -2px 0 rgba(214,166,64,.55)}\n.day-head.today .date{color:#8A6516;font-weight:800}\n.month-day.today{background:var(--gold-soft);box-shadow:inset 0 0 0 1px rgba(214,166,64,.38)}\n.month-day.today .month-num{display:inline-grid;place-items:center;min-width:24px;height:24px;border-radius:999px;background:rgba(214,166,64,.20);color:#7A5710}\n.day-view-head.today{background:var(--gold-soft);color:#7A5710}\n.calendar-nav{margin-bottom:10px}\n.editor-tabs{margin-bottom:12px}\n.editor-tabs .tab{padding:8px 7px}\n.replicate-btn{margin-top:10px}\n.footer-actions{margin-top:12px}\n\n/* interacción y feedback final */\n.selection-note{transition:background .16s ease,border-color .16s ease,color .16s ease}\n.selection-note.state-available{background:rgba(130,177,148,.10);border-color:rgba(130,177,148,.28);color:#496158}\n.selection-note.state-reserved{background:rgba(95,143,112,.12);border-color:rgba(95,143,112,.30);color:#3f5f4c}\n\n.system-menu{position:relative}.system-menu-btn{width:100%;height:38px;border:1px solid var(--border);background:rgba(255,255,255,.82);border-radius:11px;padding:0 12px;color:var(--text);display:flex;align-items:center;justify-content:space-between;font-weight:600;cursor:pointer;transition:transform .08s ease,background .15s ease,border-color .15s ease,box-shadow .15s ease}.system-menu-btn:hover,.system-menu.open .system-menu-btn{background:rgba(130,177,148,.07);border-color:rgba(130,177,148,.52);box-shadow:0 0 0 3px rgba(130,177,148,.08)}.system-menu-btn:active{transform:translateY(1px)}.system-menu-popover{display:none;position:absolute;z-index:1250;top:42px;left:0;right:0;padding:6px;background:#fff;border:1px solid var(--border);border-radius:11px;box-shadow:0 12px 30px rgba(18,34,28,.14)}.system-menu.open .system-menu-popover{display:grid;gap:2px}.system-menu-option{height:32px;border:0;border-radius:8px;background:transparent;color:#52625a;text-align:left;padding:0 10px;font-size:11px;font-weight:700;cursor:pointer}.system-menu-option:hover{background:var(--soft)}.system-menu-option.selected{background:var(--soft);color:#294439;box-shadow:inset 0 0 0 1px rgba(130,177,148,.28)}\n.btn,.tab,.nav-mini,.view-btn,.day-multi-btn,.time-picker-btn{transition:transform .08s ease,background .15s ease,border-color .15s ease,box-shadow .15s ease,opacity .15s ease}.btn:active,.tab:active,.nav-mini:active,.view-btn:active,.day-multi-btn:active,.time-picker-btn:active{transform:translateY(1px)}.btn.is-busy{pointer-events:none;opacity:.72}.btn.is-success{background:rgba(130,177,148,.16)!important;border-color:rgba(130,177,148,.42)!important;color:#294439!important}.btn.primary.is-success{background:var(--primary)!important;color:#fff!important}\n.day-multi-popover{grid-template-columns:repeat(7,minmax(0,1fr));gap:4px;padding:7px}.day-multi-option{position:relative;justify-content:center;align-items:center;padding:0 3px;height:32px;min-width:0;border:1px solid var(--border);background:rgba(255,255,255,.78);border-radius:9px;font-size:9.5px;line-height:1;font-weight:700;cursor:pointer;text-align:center;white-space:nowrap}.day-multi-option input{position:absolute;opacity:0;pointer-events:none}.day-multi-option.checked{background:rgba(130,177,148,.16);border-color:rgba(130,177,148,.62);color:#294439;box-shadow:inset 0 0 0 1px rgba(130,177,148,.10)}.day-multi-option:hover{background:rgba(130,177,148,.09);border-color:rgba(130,177,148,.38)}\n\n\n/* consolidación visual: sin azul nativo, fechas y cápsulas del sistema */\n.editor-tabs .tab.active{background:rgba(130,177,148,.11);color:#294439;box-shadow:inset 0 0 0 1px rgba(130,177,148,.24)}\n.date-picker{position:relative}.date-picker-btn{width:100%;height:38px;border:1px solid var(--border);background:rgba(255,255,255,.82);border-radius:11px;padding:0 12px;color:var(--text);display:flex;align-items:center;justify-content:space-between;font-weight:600;cursor:pointer;transition:background .15s ease,border-color .15s ease,box-shadow .15s ease,transform .08s ease}.date-picker-btn:hover,.date-picker.open .date-picker-btn{background:rgba(130,177,148,.07);border-color:rgba(130,177,148,.52);box-shadow:0 0 0 3px rgba(130,177,148,.08)}.date-picker-btn:active{transform:translateY(1px)}.date-picker-popover{display:none;position:absolute;z-index:1400;top:42px;right:0;width:244px;padding:9px;background:#fff;border:1px solid var(--border);border-radius:12px;box-shadow:0 14px 34px rgba(18,34,28,.15)}.date-picker.open .date-picker-popover{display:block}.date-picker-head{display:flex;align-items:center;justify-content:space-between;gap:6px;margin-bottom:7px}.date-picker-title{font-size:10.5px;font-weight:800;color:#344b41;text-transform:capitalize}.date-picker-nav{display:flex;gap:3px}.date-picker-nav button,.date-picker-today{height:28px;border:1px solid transparent;border-radius:8px;background:transparent;color:#52625a;font-weight:800;cursor:pointer}.date-picker-nav button{width:28px;font-size:15px}.date-picker-nav button:hover,.date-picker-today:hover{background:var(--soft);border-color:rgba(130,177,148,.26)}.date-week,.date-grid{display:grid;grid-template-columns:repeat(7,1fr);gap:2px}.date-week span{height:24px;display:grid;place-items:center;font-size:8.5px;font-weight:800;color:#7a8780}.date-day{height:28px;border:1px solid transparent;border-radius:8px;background:transparent;color:#3e4f47;font-size:9.5px;font-weight:700;cursor:pointer}.date-day:hover{background:rgba(130,177,148,.08);border-color:rgba(130,177,148,.24)}.date-day.out{color:#a4ada8}.date-day.selected{background:rgba(130,177,148,.18);border-color:rgba(130,177,148,.62);color:#294439;box-shadow:inset 0 0 0 1px rgba(130,177,148,.08)}.date-day.today{background:var(--gold-soft);border-color:rgba(214,166,64,.38);color:#7A5710}.date-day.today.selected{box-shadow:inset 0 0 0 1px rgba(130,177,148,.55)}.date-picker-footer{display:flex;justify-content:flex-end;margin-top:7px;padding-top:7px;border-top:1px solid var(--border)}.date-picker-today{padding:0 9px;color:#557866;font-size:9.5px}\ninput[type=\"checkbox\"],input[type=\"radio\"]{accent-color:var(--primary)}\n\n/* Cierre funcional 28/09 · interacción deliberada, jerarquía de estados y panel de excepciones */\n.calendar-context-final{align-items:center}\n.calendar-context-final p{max-width:690px;font-size:11.5px;line-height:1.5;color:#65726c}\n.calendar-context-final .legend{align-items:center;align-self:center}\n.agenda-slot.reserved{z-index:12!important}\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* Alcance simplificado 29/09 */\n.readonly-notice{display:none;padding:14px;border:1px solid rgba(130,177,148,.25);background:rgba(130,177,148,.07);border-radius:14px}.readonly-notice.show{display:block}.readonly-notice strong{display:block;font-size:13px;margin-bottom:5px}.readonly-notice p{margin:0 0 10px;font-size:11px;line-height:1.45;color:var(--muted)}.month-day{cursor:pointer}.day-view-readonly{display:flex;justify-content:flex-end;margin:8px 0 0}.view-btn[data-view=\"day\"]::after,.view-btn[data-view=\"month\"]::after{content:\"\"}.editor-card.readonly .editor-tabs,.editor-card.readonly .editor-panel{display:none!important}[hidden]{display:none!important}.time-picker-btn:disabled,.day-chip-inline:disabled{opacity:.55;cursor:default;background:rgba(239,240,236,.55)!important;border-color:var(--border)!important}\n.day-chip-inline:disabled.checked{background:rgba(130,177,148,.17)!important;border-color:rgba(130,177,148,.58)!important;color:#315443!important;opacity:1;}\n\n\n/* pasada fina: Solicitud de horario como referencia visual */\n:root{--reserved:#4F7F62;--reserved-strong:#426D53;--available-soft:rgba(130,177,148,.20);--reserved-soft:rgba(79,127,98,.38);}\n/* Tabs: mismo lenguaje de selección suave que Solicitud de horario */\n.editor-tabs{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px;background:transparent!important;border:0!important;padding:0!important;border-radius:0!important}\n.editor-tabs .tab{min-height:38px;border:1px solid rgba(130,177,148,.36)!important;border-radius:14px!important;background:transparent!important;color:#5F6B65!important;box-shadow:none!important}\n.editor-tabs .tab:hover{background:rgba(130,177,148,.10)!important;border-color:rgba(130,177,148,.55)!important}\n.editor-tabs .tab.active{background:rgba(130,177,148,.16)!important;border-color:var(--primary)!important;color:#32453B!important;box-shadow:none!important}\n.editor-tabs .tab:active{transform:translateY(1px)}\n/* Disponibilidad vs reservado: verdes deliberadamente distintos */\n.dot.available{background:#82B194!important}.dot.reserved{background:#4F7F62!important}\n.agenda-slot{background:var(--available-soft)!important;border-color:rgba(130,177,148,.48)!important;color:#315044!important}\n.agenda-slot.reserved{background:var(--reserved-soft)!important;border-color:rgba(79,127,98,.70)!important;color:#203D2E!important;box-shadow:inset 3px 0 0 rgba(66,109,83,.68)}\n\n.day-slot.available{background:rgba(130,177,148,.18)!important;border-color:rgba(130,177,148,.44)!important}.month-pill{background:rgba(130,177,148,.34)!important}.month-pill.reserved{background:rgba(79,127,98,.70)!important}\n/* Aplicar a: mismas cápsulas que el selector por bloque de Solicitud */\n.day-multi.open .day-multi-popover{display:grid!important;grid-template-columns:repeat(7,minmax(0,1fr))!important;gap:6px!important;padding:8px!important}\n.day-multi-option{height:34px!important;min-width:0!important;padding:0 4px!important;border-radius:10px!important;background:rgba(255,255,255,.72)!important;border:1px solid rgba(19,35,29,.12)!important;color:var(--muted)!important;font-size:10px!important;font-weight:800!important;display:grid!important;place-items:center!important}\n.day-multi-option:hover{background:rgba(130,177,148,.10)!important;border-color:rgba(130,177,148,.34)!important}\n.day-multi-option.checked{background:rgba(130,177,148,.16)!important;border-color:rgba(130,177,148,.48)!important;color:#426652!important;box-shadow:none!important}\n/* Campos: altura, radio y peso alineados al editor de Solicitud */\n.time-picker-btn,.day-multi-btn,.system-menu-btn,.date-picker-btn{height:38px!important;border-radius:10px!important;font-size:11.5px;font-weight:700}\n.time-option,.system-menu-option{font-size:11px}.time-option.selected,.system-menu-option.selected{background:rgba(130,177,148,.16)!important;color:#294439!important;box-shadow:inset 0 0 0 1px rgba(130,177,148,.30)!important}\n/* Estados interactivos visibles en todo el módulo derecho */\n\n.back:hover,.btn.secondary:hover{background:rgba(130,177,148,.10)!important;border-color:rgba(130,177,148,.48)!important}\n\n.btn.secondary:active,.back:active{background:rgba(130,177,148,.17)!important;border-color:var(--primary)!important}\n.btn.primary:hover{background:var(--primary-dark)!important}.btn.primary:active{background:#668E76!important;box-shadow:0 2px 7px rgba(102,142,118,.18)!important}\n.btn:focus-visible,.back:focus-visible,.tab:focus-visible,.nav-mini:focus-visible,.view-btn:focus-visible,.day-multi-btn:focus-visible,.time-picker-btn:focus-visible,.system-menu-btn:focus-visible,.date-picker-btn:focus-visible{outline:2px solid rgba(130,177,148,.38);outline-offset:2px}\n.nav-mini:hover,.view-btn:hover{background:rgba(130,177,148,.10)!important;border-color:rgba(130,177,148,.38)!important}.view-btn.active{background:rgba(130,177,148,.16)!important;color:#294439!important}\n\n\n/* Leyenda con mejor lectura */\n.legend{column-gap:14px;row-gap:6px}.legend span{display:inline-flex;align-items:center}.dot{width:9px;height:9px;margin-right:6px}\n\n/* Alcance simplificado 29/09 */\n.readonly-notice{display:none;padding:14px;border:1px solid rgba(130,177,148,.25);background:rgba(130,177,148,.07);border-radius:14px}.readonly-notice.show{display:block}.readonly-notice strong{display:block;font-size:13px;margin-bottom:5px}.readonly-notice p{margin:0 0 10px;font-size:11px;line-height:1.45;color:var(--muted)}.month-day{cursor:pointer}.day-view-readonly{display:flex;justify-content:flex-end;margin:8px 0 0}.view-btn[data-view=\"day\"]::after,.view-btn[data-view=\"month\"]::after{content:\"\"}.editor-card.readonly .editor-tabs,.editor-card.readonly .editor-panel{display:none!important}[hidden]{display:none!important}.time-picker-btn:disabled,.day-chip-inline:disabled{opacity:.55;cursor:default;background:rgba(239,240,236,.55)!important;border-color:var(--border)!important}\n.day-chip-inline:disabled.checked{background:rgba(130,177,148,.17)!important;border-color:rgba(130,177,148,.58)!important;color:#315443!important;opacity:1;}\n\n\n/* Cierre fino · encabezado, Aplicar a directo y excepciones funcionales */\n.calendar-header-v2{display:flex;align-items:flex-start;justify-content:space-between;gap:16px;margin-bottom:9px}.calendar-heading-v2{min-width:0}.calendar-title-line{display:flex;align-items:baseline;gap:8px;flex-wrap:wrap}.calendar-title-line h2{margin:0;font-size:15px;line-height:1.2}.calendar-title-line .period-label{font-size:11px;font-weight:700;color:#53645b}.calendar-heading-v2 p{margin:4px 0 0;max-width:650px;font-size:10.5px;line-height:1.45;color:var(--muted)}.calendar-subbar-v2{min-height:34px;display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:9px;padding-top:7px;border-top:1px solid rgba(16,25,21,.07)}.calendar-subbar-v2 .period-nav{display:flex;align-items:center;gap:6px}.calendar-subbar-v2 .nav-mini{height:30px;min-width:30px}.calendar-subbar-v2 .today-control{padding:0 10px}.view-switch{flex:0 0 auto}.legend{justify-content:flex-end}.dot.available{background:#B8D7C3!important;border:1px solid #82B194}.dot.reserved{background:#4F7F62!important;border:1px solid #426D53}.agenda-slot{background:rgba(130,177,148,.18)!important;border-color:rgba(130,177,148,.46)!important}.agenda-slot.reserved{background:rgba(79,127,98,.42)!important;border-color:rgba(66,109,83,.72)!important}.apply-days-field{margin-bottom:11px}.day-chips-inline{display:grid;grid-template-columns:repeat(7,minmax(0,1fr));gap:5px}.day-chip-inline{height:32px;min-width:0;padding:0 2px;border:1px solid rgba(19,35,29,.12);border-radius:9px;background:rgba(255,255,255,.78);color:#65726b;font-size:9px;line-height:1;font-weight:800;display:grid;place-items:center;cursor:pointer;transition:background .15s ease,border-color .15s ease,color .15s ease,transform .08s ease}.day-chip-inline:hover{background:rgba(130,177,148,.09);border-color:rgba(130,177,148,.38)}.day-chip-inline.checked{background:rgba(130,177,148,.17);border-color:rgba(130,177,148,.58);color:#315443}.day-chip-inline.origin{box-shadow:inset 0 0 0 1px rgba(130,177,148,.18)}.day-chip-inline:active{transform:translateY(1px)}.day-chip-inline:focus-visible{outline:2px solid rgba(130,177,148,.34);outline-offset:2px}\n@media (max-width:980px){.calendar-header-v2{align-items:stretch}.calendar-header-v2,.calendar-subbar-v2{flex-wrap:wrap}.legend{justify-content:flex-start}.day-chips-inline{grid-template-columns:repeat(7,minmax(34px,1fr))}}\n\n/* Alcance simplificado 29/09 */\n.readonly-notice{display:none;padding:14px;border:1px solid rgba(130,177,148,.25);background:rgba(130,177,148,.07);border-radius:14px}.readonly-notice.show{display:block}.readonly-notice strong{display:block;font-size:13px;margin-bottom:5px}.readonly-notice p{margin:0 0 10px;font-size:11px;line-height:1.45;color:var(--muted)}.month-day{cursor:pointer}.day-view-readonly{display:flex;justify-content:flex-end;margin:8px 0 0}.view-btn[data-view=\"day\"]::after,.view-btn[data-view=\"month\"]::after{content:\"\"}.editor-card.readonly .editor-tabs,.editor-card.readonly .editor-panel{display:none!important}[hidden]{display:none!important}.time-picker-btn:disabled,.day-chip-inline:disabled{opacity:.55;cursor:default;background:rgba(239,240,236,.55)!important;border-color:var(--border)!important}\n.day-chip-inline:disabled.checked{background:rgba(130,177,148,.17)!important;border-color:rgba(130,177,148,.58)!important;color:#315443!important;opacity:1;}\n\n\n/* cierre funcional para QA previo a desarrollo */\n.calendar-header-final{display:grid;grid-template-columns:auto minmax(210px,1fr) auto;align-items:center;gap:14px;margin-bottom:8px}.calendar-header-final .period-nav{display:flex;gap:6px;align-items:center}.period-focus{text-align:center;display:grid;justify-items:center;gap:2px;min-width:0;padding:7px 16px;border:1px solid rgba(16,25,21,.08);border-radius:12px;background:rgba(255,255,255,.62)}.period-mode{font-size:9.5px;font-weight:800;letter-spacing:.08em;text-transform:uppercase;color:#738079}.period-focus .period-label{min-width:0;font-size:17px;line-height:1.15;font-weight:800;color:#31463d;letter-spacing:-.02em}.calendar-context-final{display:flex;align-items:flex-start;justify-content:space-between;gap:14px;margin-bottom:10px;padding-top:8px;border-top:1px solid rgba(16,25,21,.07)}.calendar-context-final p{margin:0;max-width:660px;font-size:10.5px;line-height:1.45;color:var(--muted)}.calendar-context-final .legend{justify-content:flex-end}.time-label-final{position:absolute;left:0;bottom:2px;width:56px;transform:none;text-align:center;font-size:9px;color:#89938E;z-index:8;pointer-events:none;background:linear-gradient(to right,rgba(255,255,255,.92),rgba(255,255,255,.55));padding:1px 0}.day-lane{min-height:594px!important;background:repeating-linear-gradient(to bottom,transparent 0,transparent 47px,rgba(16,25,21,.055) 48px)!important}.period-nav .nav-mini:active,.view-btn:active,.btn:active,.tab:active,.day-chip-inline:active,.system-menu-btn:active,.time-picker-btn:active,.date-picker-btn:active{transform:translateY(1px)}.agenda-slot.reserved{z-index:7}.calendar-card{overflow:visible}@media (max-width:980px){.calendar-header-final{grid-template-columns:1fr auto}.period-focus{grid-column:1/-1;grid-row:1}.period-nav{grid-column:1;grid-row:2}.calendar-header-final .view-switch{grid-column:2;grid-row:2}.calendar-context-final{flex-wrap:wrap}.calendar-context-final .legend{justify-content:flex-start}}\n\n/* Alcance simplificado 29/09 */\n.readonly-notice{display:none;padding:14px;border:1px solid rgba(130,177,148,.25);background:rgba(130,177,148,.07);border-radius:14px}.readonly-notice.show{display:block}.readonly-notice strong{display:block;font-size:13px;margin-bottom:5px}.readonly-notice p{margin:0 0 10px;font-size:11px;line-height:1.45;color:var(--muted)}.month-day{cursor:pointer}.day-view-readonly{display:flex;justify-content:flex-end;margin:8px 0 0}.view-btn[data-view=\"day\"]::after,.view-btn[data-view=\"month\"]::after{content:\"\"}.editor-card.readonly .editor-tabs,.editor-card.readonly .editor-panel{display:none!important}[hidden]{display:none!important}.time-picker-btn:disabled,.day-chip-inline:disabled{opacity:.55;cursor:default;background:rgba(239,240,236,.55)!important;border-color:var(--border)!important}\n.day-chip-inline:disabled.checked{background:rgba(130,177,148,.17)!important;border-color:rgba(130,177,148,.58)!important;color:#315443!important;opacity:1;}\n\n\n/* =========================================================================\n   Reserva directa · V28 Layout Oficial (editor-profesional-v28.css)\n   ========================================================================= */\n\n.workspace {\n  display: grid !important;\n  grid-template-columns: minmax(0, calc(66.666667% - 28px)) minmax(0, 1fr) !important;\n  column-gap: 22px !important;\n  grid-template-rows: auto auto !important;\n  row-gap: 0 !important;\n  align-items: start !important;\n  padding: 0 !important;\n  margin: 12px 0 0 !important;\n  background: transparent !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  width: 100% !important;\n}\n\n.calendar-layout {\n  display: contents !important;\n}\n\n.calendar-card {\n  grid-column: 1 !important;\n  grid-row: 1 !important;\n  width: 100% !important;\n  min-width: 0 !important;\n  max-width: 100% !important;\n  height: auto !important;\n  min-height: 0 !important;\n  max-height: none !important;\n  padding: 24px !important;\n  border: 1px solid rgba(16, 25, 21, 0.05) !important;\n  border-radius: 24px !important;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03) !important;\n  overflow: visible !important;\n  background: #F7F5F1 !important;\n}\n\n.workspace > #editorActionZone {\n  grid-column: 1 !important;\n  grid-row: 2 !important;\n  position: sticky !important;\n  bottom: 20px !important;\n  top: auto !important;\n  z-index: 40 !important;\n  box-sizing: border-box !important;\n  width: 100% !important;\n  max-width: none !important;\n  margin: 0 !important;\n  padding: 16px 0 0 !important;\n}\n\n#editorActionZone .save-pill {\n  box-sizing: border-box !important;\n  width: 100% !important;\n  min-height: 74px !important;\n  height: auto !important;\n  display: flex !important;\n  flex-direction: row !important;\n  flex-wrap: nowrap !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  gap: 14px !important;\n  padding: 12px 12px 12px 24px !important;\n  border-radius: 28px !important;\n  background: linear-gradient(90deg, #F8F0D4 0%, #FCF8EA 28%, #F7F5F1 52%, #F7F5F1 100%) !important;\n  border: 1px solid rgba(16, 25, 21, 0.08) !important;\n  box-shadow: 0 10px 18px rgba(18, 34, 28, 0.10) !important;\n  animation: da-slideUp 0.4s ease-out forwards;\n}\n\n#editorActionZone .save-state {\n  flex: 1 1 auto !important;\n  min-width: 0 !important;\n  display: flex !important;\n  align-items: flex-start !important;\n  gap: 10px !important;\n}\n\n#editorActionZone .save-dot {\n  width: 10px !important;\n  height: 10px !important;\n  border-radius: 999px !important;\n  background: #D6A640 !important;\n  flex: 0 0 10px !important;\n  margin-top: 5px !important;\n  transition: background-color 0.3s ease, opacity 0.25s ease !important;\n\n  &.save-dot--saved {\n    background-color: rgba(19, 35, 29, 0.18) !important;\n  }\n}\n\n#editorActionZone .save-copy {\n  font-size: 13px !important;\n  font-weight: 800 !important;\n  color: #13231D !important;\n  line-height: 1.25 !important;\n  margin-bottom: 2px !important;\n}\n\n#editorActionZone .save-sub {\n  font-size: 12px !important;\n  line-height: 1.35 !important;\n  color: #6C7771 !important;\n}\n\n#editorActionZone .save-actions {\n  flex: 0 0 auto !important;\n  display: grid !important;\n  grid-template-columns: 104px 148px !important;\n  align-items: stretch !important;\n  gap: 10px !important;\n  flex-wrap: nowrap !important;\n  width: auto !important;\n}\n\n#editorActionZone .save-actions > button {\n  width: 100% !important;\n  min-width: 0 !important;\n  height: 42px !important;\n  min-height: 42px !important;\n  padding: 0 10px !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  border-radius: 14px !important;\n  white-space: nowrap !important;\n  font-size: 13px !important;\n  font-weight: 800 !important;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n#editorActionZone .save-actions .btn-save-exit {\n  background: transparent !important;\n  border: 1px solid rgba(130, 177, 148, 0.40) !important;\n  color: #13231D !important;\n\n  &:hover {\n    background: rgba(130, 177, 148, 0.05) !important;\n  }\n}\n\n#editorActionZone .save-actions .save-cta {\n  background: #82B194 !important;\n  border: none !important;\n  color: #fff !important;\n  box-shadow: none !important;\n\n  &:hover:not(:disabled) {\n    background: #6F9A80 !important;\n    transform: translateY(-1px);\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n\n.calendar-card > .head {\n  display: block !important;\n  margin: 0 0 24px !important;\n  padding: 0 !important;\n}\n\n.calendar-card > .head h1 {\n  font-size: 20px !important;\n  letter-spacing: -0.025em !important;\n  line-height: 1.3 !important;\n  font-weight: 800 !important;\n  margin: 0 !important;\n  color: var(--text, #13231D) !important;\n}\n\n.calendar-card > .head p {\n  margin: 6px 0 0 !important;\n  line-height: 1.55 !important;\n  font-size: 13px !important;\n  color: var(--muted, #6C7771) !important;\n}\n\n.calendar-card .calendar-header-final {\n  display: grid !important;\n  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr) !important;\n  align-items: center !important;\n  gap: 8px !important;\n  margin-bottom: 12px !important;\n}\n\n.calendar-header-final .period-nav {\n  justify-self: start !important;\n  display: flex !important;\n  align-items: center !important;\n  gap: 6px !important;\n}\n\n.calendar-header-final .period-focus {\n  justify-self: center !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  width: max-content !important;\n  min-width: 154px !important;\n  max-width: 100% !important;\n  height: 34px !important;\n  min-height: 34px !important;\n  max-height: 34px !important;\n  padding: 2px 14px !important;\n  border: 1px solid rgba(16, 25, 21, 0.08) !important;\n  border-radius: 12px !important;\n  background: rgba(255, 255, 255, 0.62) !important;\n}\n\n.calendar-header-final .period-focus .period-label {\n  font-size: 17px !important;\n  line-height: 1.15 !important;\n  font-weight: 800 !important;\n  color: #31463d !important;\n  letter-spacing: -0.02em !important;\n}\n\n.calendar-header-final .view-switch {\n  justify-self: end !important;\n  display: flex !important;\n  align-items: center !important;\n  width: max-content !important;\n  height: 34px !important;\n  min-height: 34px !important;\n  max-height: 34px !important;\n  padding: 2px !important;\n  background: rgba(255, 255, 255, 0.5) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: 12px !important;\n}\n\n.calendar-header-final .period-nav .nav-mini {\n  height: 34px !important;\n  min-height: 34px !important;\n  border-radius: 10px !important;\n}\n\n.calendar-header-final .view-btn {\n  height: 28px !important;\n  min-height: 28px !important;\n  border-radius: 9px !important;\n  padding-inline: 10px !important;\n}\n\n.calendar-context-final {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  gap: 14px !important;\n  margin-bottom: 12px !important;\n  padding-top: 10px !important;\n  border-top: 1px solid rgba(16, 25, 21, 0.07) !important;\n}\n\n#calendarHelp {\n  max-width: none !important;\n  min-width: 0 !important;\n  flex: 1 1 auto !important;\n  margin: 0 !important;\n  padding: 10px 12px !important;\n  border: 1px solid rgba(214, 166, 64, 0.35) !important;\n  border-radius: 12px !important;\n  background: #F8F4E7 !important;\n  color: #13231D !important;\n  font-weight: 600 !important;\n  font-size: 11px !important;\n  line-height: 1.55 !important;\n}\n\n.calendar-context-final .legend {\n  flex: 0 0 auto !important;\n  display: flex !important;\n  align-items: center !important;\n  gap: 14px !important;\n  margin: 0 !important;\n}\n\n.week-grid {\n  grid-template-columns: 56px repeat(7, minmax(0, 1fr)) !important;\n  width: 100% !important;\n  min-width: 0 !important;\n  max-width: 100% !important;\n}\n\n.editor-column {\n  position: sticky !important;\n  top: 94px !important;\n  display: flex !important;\n  flex-direction: column !important;\n  align-self: stretch !important;\n  width: 100% !important;\n  max-width: none !important;\n  min-width: 0 !important;\n  height: 100% !important;\n  min-height: calc(100vh - 122px) !important;\n  overflow: visible !important;\n}\n\n.editor-column .editor-card {\n  position: static !important;\n  width: 100% !important;\n  flex: 1 1 auto !important;\n  display: flex !important;\n  flex-direction: column !important;\n  min-height: 100% !important;\n  padding: 24px !important;\n  background: #F7F5F1 !important;\n  border: 1px solid rgba(16, 25, 21, 0.05) !important;\n  border-radius: 24px !important;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03) !important;\n  overflow: visible !important;\n}\n\n.editor-card h2 {\n  font-size: 16px !important;\n  font-weight: 800 !important;\n  margin: 0 0 5px !important;\n}\n\n.editor-card .lead {\n  font-size: 12px !important;\n  line-height: 1.45 !important;\n  color: var(--muted, #6C7771) !important;\n  margin: 0 0 14px !important;\n}\n\n.editor-tabs {\n  display: grid !important;\n  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n  gap: 8px !important;\n  margin: 0 0 16px !important;\n  padding: 0 !important;\n  background: transparent !important;\n  border: 0 !important;\n}\n\n.editor-tabs .tab {\n  min-height: 38px !important;\n  border: 1px solid rgba(130, 177, 148, 0.36) !important;\n  border-radius: 12px !important;\n  background: transparent !important;\n  color: #5F6B65 !important;\n  font-size: 12px !important;\n  font-weight: 700 !important;\n}\n\n.editor-tabs .tab.active {\n  background: rgba(130, 177, 148, 0.16) !important;\n  border-color: var(--primary, #82B194) !important;\n  color: #32453B !important;\n  box-shadow: none !important;\n}\n\n.selection-note {\n  padding: 10px 12px !important;\n  background: rgba(130, 177, 148, 0.08) !important;\n  border: 1px solid rgba(130, 177, 148, 0.20) !important;\n  border-radius: 12px !important;\n  font-size: 11px !important;\n  line-height: 1.5 !important;\n  color: #5d6d65 !important;\n  margin-bottom: 12px !important;\n}\n\n.field label {\n  display: block !important;\n  font-size: 10px !important;\n  font-weight: 800 !important;\n  color: #6D7872 !important;\n  margin: 0 0 6px !important;\n  letter-spacing: 0.02em !important;\n}\n\n.time-picker-btn, .day-multi-btn, .system-menu-btn, .date-picker-btn {\n  height: 38px !important;\n  border-radius: 14px !important;\n  font-size: 12px !important;\n  font-weight: 700 !important;\n}\n\n.day-chips-inline {\n  display: grid !important;\n  grid-template-columns: repeat(7, minmax(0, 1fr)) !important;\n  gap: 5px !important;\n}\n\n.day-chip-inline {\n  height: 34px !important;\n  border-radius: 10px !important;\n  font-size: 9.5px !important;\n  font-weight: 800 !important;\n}\n\n.availability-actions {\n  display: grid !important;\n  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n  gap: 8px !important;\n  width: 100% !important;\n  margin-top: 4px !important;\n}\n\n.availability-actions .btn {\n  height: 40px !important;\n  border-radius: 14px !important;\n  font-weight: 800 !important;\n  font-size: 12px !important;\n}\n\n.pause-inline-field {\n  margin-top: 14px !important;\n  margin-bottom: 12px !important;\n}\n\n.pause-inline-row {\n  display: grid !important;\n  grid-template-columns: 112px minmax(0, 1fr) !important;\n  gap: 12px !important;\n  align-items: center !important;\n}\n\n.replicate-btn {\n  width: 100% !important;\n  height: 40px !important;\n  border-radius: 14px !important;\n  margin-top: 14px !important;\n  font-weight: 800 !important;\n  font-size: 12px !important;\n}\n\n@media (max-width: 1380px) {\n  .workspace {\n    grid-template-columns: minmax(0, 1fr) !important;\n    row-gap: 20px !important;\n  }\n  .calendar-layout {\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 20px !important;\n  }\n  .calendar-card {\n    grid-column: auto !important;\n    grid-row: auto !important;\n    width: 100% !important;\n  }\n  .editor-column {\n    grid-column: auto !important;\n    grid-row: auto !important;\n    position: static !important;\n    max-height: none !important;\n    width: 100% !important;\n  }\n  .workspace > #editorActionZone {\n    grid-column: auto !important;\n    grid-row: auto !important;\n    width: 100% !important;\n  }\n}\n\n/* Botón de eliminación en panel derecho y contenedor informativo */\n.selected-range-info{display:flex!important;align-items:center!important;justify-content:space-between!important;gap:12px!important;min-width:0!important}\n.selected-range-copy{flex:1 1 auto;min-width:0;overflow-wrap:anywhere}\n.delete-slot-icon{flex:0 0 34px;width:34px;height:34px;display:inline-flex;align-items:center;justify-content:center;background:transparent;color:#D95C5C;border:1px solid #D95C5C;border-radius:12px!important;cursor:pointer;transition:all .15s ease;padding:0;align-self:center}\n.delete-slot-icon:hover,.delete-slot-icon:focus-visible{background:#D95C5C;color:#fff;outline-offset:2px}\n.delete-slot-icon[hidden]{display:none!important}\n\n.day-slot.reserved{background:rgba(95,143,112,.26)!important;border:1px solid rgba(66,109,83,.68)!important;color:#2d4838!important;box-shadow:none!important}\n.agenda-slot.reserved{border:1px solid rgba(66,109,83,.68)!important;box-shadow:none!important;border-radius:7px!important}\n.pause-compact-menu{width:112px;min-width:112px}\n.pause-compact-menu .system-menu-btn{width:100%}\n.pause-inline-help{margin:0!important;font-size:10px!important;line-height:1.45!important;color:var(--muted);align-self:center}\n@media (max-width:520px){.pause-inline-row{grid-template-columns:1fr}.pause-compact-menu{width:100%;min-width:0}.pause-inline-help{margin-top:2px!important}}\n\n\n/* Reserva directa · acciones de edición de disponibilidad. */\n.editor-tabs .tab[data-editor-tab=\"dateAdjustmentsEditor\"]{background:transparent!important;border-color:rgba(130,177,148,.30)!important;color:#43584e!important}\n.editor-tabs .tab[data-editor-tab=\"dateAdjustmentsEditor\"]:hover{background:rgba(130,177,148,.10)!important;border-color:rgba(130,177,148,.42)!important;color:#32453B!important}\n.editor-tabs .tab[data-editor-tab=\"dateAdjustmentsEditor\"].active{background:rgba(130,177,148,.16)!important;border-color:var(--primary)!important;color:#32453B!important;box-shadow:none!important}\n.availability-edit-note{background:rgba(159,169,165,.12)!important;border-color:rgba(159,169,165,.48)!important;color:#56635D!important}\n.date-adjust-status{margin-bottom:14px!important}\n.date-adjust-actions{display:grid;grid-template-columns:1fr;gap:8px;margin-top:4px}\n.date-adjust-actions .btn{width:100%}\n#restoreHabitual{margin-top:8px}\n.btn.is-feedback{pointer-events:none}\n.btn.is-invalid{background:rgba(159,169,165,.16)!important;border-color:rgba(159,169,165,.70)!important;color:#46524D!important}\n.agenda-slot.adjusted{box-shadow:inset 0 0 0 1px rgba(130,177,148,.30)}\n\n.editor-action-zone .toast{display:none!important}\n@media (min-width:1321px) and (max-height:900px){.date-adjust-status{margin-bottom:12px!important}}\n\n/* Distribución aprobada de CTA: fila principal completa + tercer CTA full width. */\n.availability-actions{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px;width:100%}\n.availability-actions .btn{width:100%;min-width:0}\n/* Acceso directo contextual a Editar disponibilidad. */\n.edit-availability-direct{display:block;width:100%;margin-top:8px;height:35px;min-height:35px!important;border:1px solid rgba(130,177,148,.52)!important;border-radius:10px;background:rgba(130,177,148,.055)!important;color:#375247!important;font-size:11px;font-weight:800;cursor:pointer;transition:background .15s,border-color .15s}\n.edit-availability-direct:hover{background:rgba(130,177,148,.15)!important;border-color:#82B194!important}\n.edit-availability-direct[aria-pressed=\"true\"]{background:rgba(130,177,148,.19)!important;border-color:#82B194!important}\n.edit-availability-direct:focus-visible{outline:2px solid rgba(130,177,148,.45);outline-offset:2px}\n.edit-availability-direct[hidden]{display:none!important}\n\n\n.draft-selection {\n  position: relative;\n  margin: 2px 3px;\n  border-radius: 8px;\n  background: rgba(16, 25, 21, 0.05);\n  border: 1px dashed rgba(16, 25, 21, 0.25);\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 5px 4px;\n  font-size: 9px;\n  line-height: 1.3;\n  font-weight: 800;\n  color: #315044;\n  z-index: 6;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n/* Context menu: visible when .open, positioned fixed by React inline styles */\n.context-menu {\n  position: fixed !important;\n  z-index: 2000 !important;\n  display: none;\n  width: 220px !important;\n  min-width: 220px !important;\n  max-width: calc(100vw - 16px) !important;\n  padding: 6px !important;\n  background: #fff !important;\n  border: 1px solid rgba(16, 25, 21, 0.10) !important;\n  border-radius: 12px !important;\n  box-shadow: 0 12px 30px rgba(18, 34, 28, 0.14) !important;\n\n  &.open {\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 2px !important;\n  }\n\n  button {\n    width: 100% !important;\n    display: flex !important;\n    align-items: center !important;\n    gap: 9px !important;\n    text-align: left !important;\n    padding: 11px 10px !important;\n    border: 0 !important;\n    border-radius: 9px !important;\n    background: transparent !important;\n    color: #13231D !important;\n    font: 600 11px Sora, system-ui, sans-serif !important;\n    cursor: pointer !important;\n    transition: background 0.15s ease !important;\n\n    &:hover {\n      background: rgba(130, 177, 148, 0.12) !important;\n    }\n\n    &.context-danger {\n      color: #D95C5C !important;\n      border-top: 1px solid rgba(16, 25, 21, 0.10) !important;\n      border-radius: 0 0 9px 9px !important;\n      margin-top: 3px !important;\n      padding-top: 12px !important;\n\n      &:hover {\n        background: rgba(217, 92, 92, 0.08) !important;\n      }\n    }\n  }\n}\n\n/* Replicate modal */\n.replicate-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(19, 35, 29, 0.28);\n  display: none;\n  align-items: center;\n  justify-content: center;\n  z-index: 3000;\n  padding: 20px;\n  backdrop-filter: blur(2px);\n}\n.replicate-backdrop.open { display: flex; }\n.modal-card {\n  width: min(460px, 100%);\n  background: #F7F5F1;\n  border: 1px solid rgba(16, 25, 21, 0.10);\n  border-radius: 20px;\n  padding: 22px;\n  box-shadow: 0 24px 60px rgba(18, 34, 28, 0.18);\n}\n.modal-card h3 { margin: 0 0 6px; font-size: 18px; }\n.modal-card p { margin: 0 0 18px; font-size: 11px; line-height: 1.55; color: var(--muted); }\n.modal-header { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 6px; }\n.modal-close { background: none; border: none; cursor: pointer; color: var(--muted); font-size: 18px; line-height: 1; padding: 0; }\n.modal-close:hover { color: var(--text); }\n.replicate-actions { display: flex; justify-content: flex-end; gap: 8px; margin-top: 18px; }\n.radio-stack { display: grid; gap: 8px; margin-top: 8px; }\n.radio-row {\n  display: flex;\n  gap: 9px;\n  align-items: flex-start;\n  padding: 9px 10px;\n  border: 1px solid var(--border);\n  border-radius: 11px;\n  background: rgba(255, 255, 255, 0.6);\n  font-size: 11px;\n  color: #56645e;\n  cursor: pointer;\n  transition: border-color 0.15s, background 0.15s;\n}\n.radio-row:hover { background: var(--soft); border-color: rgba(130, 177, 148, 0.36); }\n.radio-row input { accent-color: var(--primary); margin-top: 2px; }\n.replicate-error {\n  padding: 10px 11px;\n  background: rgba(220, 53, 69, 0.08);\n  border: 1px solid rgba(220, 53, 69, 0.18);\n  border-radius: 11px;\n  font-size: 10px;\n  line-height: 1.5;\n  color: #a51b29;\n  margin-top: 12px;\n}\n\n.replicate-note {\n  padding: 10px 11px;\n  background: rgba(130, 177, 148, 0.08);\n  border: 1px solid rgba(130, 177, 148, 0.18);\n  border-radius: 11px;\n  font-size: 10px;\n  line-height: 1.5;\n  color: #5d6d65;\n  margin-top: 12px;\n}\n\n.replicate-backdrop.open {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.replicate-backdrop .modal-card {\n  width: 100%;\n  max-width: 420px;\n  padding: 24px;\n  border-radius: 16px;\n  box-shadow: 0 16px 40px rgba(18, 34, 28, 0.15);\n  background: #F7F5F1;\n}\n\n.replicate-backdrop .modal-header h3 {\n  margin: 0 0 6px;\n  font-size: 18px;\n  font-weight: 800;\n  color: #1B2420;\n}\n\n.replicate-backdrop .modal-header p {\n  margin: 0 0 18px;\n  font-size: 11px;\n  line-height: 1.55;\n  color: var(--muted);\n}\n\n.replicate-backdrop .field label {\n  margin-bottom: 5px;\n  font-size: 9px;\n  font-weight: 800;\n  color: #738079;\n  letter-spacing: 0.04em;\n  display: block;\n}\n\n.replicate-date-wrapper {\n  --picker-h: 38px;\n  --picker-bg: #FFFFFF;\n}\n\n.replicate-date-wrapper .date-picker-btn {\n  height: 38px !important;\n  border-radius: 10px !important;\n  background: #FFFFFF !important;\n  border: 1px solid #D1DBD5 !important;\n  font-size: 13.5px !important;\n  font-weight: 800 !important;\n  color: #1B2420 !important;\n  padding: 0 12px !important;\n  position: relative;\n}\n\n.replicate-date-wrapper .date-picker-btn span:last-child {\n  color: transparent !important;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%231B2420' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  width: 20px;\n  height: 20px;\n  display: block;\n}\n\n.replicate-note {\n  padding: 10px 11px;\n  background: rgba(130, 177, 148, .08);\n  border: 1px solid rgba(130, 177, 148, .18);\n  border-radius: 11px;\n  font-size: 10px;\n  line-height: 1.5;\n  color: #5d6d65;\n  margin-top: 12px;\n  font-weight: 500;\n}\n\n.replicate-actions {\n  margin-top: 20px;\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.replicate-actions .btn {\n  border-radius: 10px;\n  height: 36px;\n  padding: 0 16px;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.replicate-actions .btn.secondary {\n  color: #1B2420;\n  background: #FFFFFF;\n  border: 1px solid #D1DBD5;\n}\n\n.replicate-actions .btn.primary {\n  background: #84B396;\n  color: #FFFFFF;\n  border: none;\n}\n\n/* ── Floating Save Bar (Disponibilidad) ───────────────────── */\n.da-save-bar {\n  position: sticky;\n  bottom: 20px;\n  z-index: 1100;\n  padding-top: 10px;\n  margin-top: 2px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  animation: da-slideUp 0.4s ease-out forwards;\n\n  &__pill {\n    min-height: 74px;\n    width: 100%;\n    max-width: 1100px;\n    border-radius: 28px;\n    background: linear-gradient(90deg, #F8F0D4 0%, #FCF8EA 28%, #FAFBF9 52%, #FAFBF9 100%);\n    border: 1px solid rgba(16, 25, 21, 0.08);\n    box-shadow: 0 10px 18px rgba(18, 34, 28, 0.10);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 14px;\n    padding: 12px 12px 12px 16px;\n\n    &--dirty {\n      background: linear-gradient(90deg, #DCEADF 0%, #EAF3ED 28%, #FAFBF9 52%, #FAFBF9 100%);\n    }\n  }\n\n  &__state {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    min-width: 0;\n  }\n\n  &__dot {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background: #D6A640;\n    flex: 0 0 10px;\n    margin-top: 6px;\n    transition: background 0.25s ease;\n\n    &--dirty {\n      background: #82B194;\n    }\n\n    &--saved {\n      background: rgba(19, 35, 29, 0.18);\n    }\n  }\n\n  &__info {\n    display: flex;\n    flex-direction: column;\n  }\n\n  &__title {\n    font-size: 13px;\n    font-weight: 800;\n    color: #101915;\n    line-height: 1.25;\n    margin-bottom: 2px;\n  }\n\n  &__subtitle {\n    font-size: 12px;\n    color: #6B7A71;\n    line-height: 1.35;\n  }\n\n  &__actions {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-shrink: 0;\n  }\n\n  &__btn-exit {\n    min-width: 104px;\n    min-height: 42px;\n    border-radius: 14px;\n    background: transparent;\n    border: 1px solid rgba(130, 177, 148, 0.40);\n    color: #101915;\n    font-size: 13px;\n    font-weight: 800;\n    cursor: pointer;\n    transition: all 0.2s ease;\n\n    &:hover {\n      background: rgba(130, 177, 148, 0.05);\n    }\n  }\n\n  &__btn-save {\n    min-width: 160px;\n    min-height: 42px;\n    border-radius: 14px;\n    background: #82B194;\n    color: #ffffff;\n    border: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 13px;\n    font-weight: 800;\n    padding: 0 18px;\n    cursor: pointer;\n    transition: background 0.2s ease, transform 0.2s ease;\n\n    &:hover:not(:disabled) {\n      background: #6A9A7C;\n      transform: translateY(-1px);\n    }\n\n    &:disabled {\n      opacity: 0.6;\n      cursor: not-allowed;\n    }\n  }\n\n  &__spinner {\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    border: 2px solid rgba(255,255,255,0.4);\n    border-top-color: #fff;\n    border-radius: 50%;\n    animation: da-spin 0.7s linear infinite;\n  }\n}\n\n@keyframes da-slideUp {\n  from { transform: translateY(30px); opacity: 0; }\n  to   { transform: translateY(0);    opacity: 1; }\n}\n\n@keyframes da-spin {\n  to { transform: rotate(360deg); }\n}\n\n@media (max-width: 700px) {\n  .da-save-bar {\n    bottom: 14px;\n\n    &__pill {\n      border-radius: 24px;\n      flex-direction: column;\n      align-items: stretch;\n      padding: 14px;\n      height: auto;\n    }\n\n    &__btn-save,\n    &__btn-exit {\n      width: 100%;\n      min-width: 0;\n    }\n  }\n}\n\n.empty-week-banner {\n  padding: 12px 16px;\n  background-color: #FFF4E5;\n  color: #663C00;\n  border-radius: 4px;\n  margin-bottom: 16px;\n  font-size: 12px;\n  border: 1px solid #FFD8A8;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
